I18NFile = { all: {
  "Accepted": {
    "de": "Akzeptiert",
    "es": "Aceptado",
    "fr": "Accepté(e)",
    "it": "Accettato",
    "jp": "受領",
    "pt": "Aceito",
    "ru": "подтвержденный",
    "sv": "Godkänd",
    "zh": "已接受",
    "ko": "오더진행 완료"
  },
  "Actual Customer Ship Date": {
    "de": "Tatsächliches Versanddatum",
    "es": "Fecha actual del envío",
    "fr": "Date d'expédition",
    "it": "Data spedizione effettiva al cliente",
    "jp": "HP出荷日",
    "pt": "Data real de envio",
    "ru": "Дата фактической отправки",
    "sv": "Faktiskt skeppningsdatum (till kund)",
    "zh": "实际发货日期",
    "ko": "선적날짜"
  },
  "Actual Delivery Date": {
    "de": "Tatsächliches Lieferdatum",
    "es": "Fecha actual de entrega",
    "fr": "Date de livraison",
    "it": "Data Consegna",
    "jp": "(未使用)納品日",
    "pt": "Data real de entrega",
    "ru": "Фактическая дата поставки",
    "sv": "Faktiskt leveransdatum",
    "zh": "实际交货日期",
    "ko": "납품날짜"
  },
  "Additional Info": {
    "de": "Zusätzliche Information",
    "es": "Información adicional",
    "fr": "Information(s) complémentaire(s)",
    "it": "Informazioni aggiuntive",
    "jp": "追加情報",
    "pt": "Informação adicional",
    "ru": "Дополнительная информация",
    "sv": "Övrig information",
    "zh": "附加信息",
    "ko": "추가정보"
  },
  "Address": {
    "de": "Adressen",
    "es": "Dirección",
    "fr": "Adresse",
    "it": "Indirizzo",
    "jp": "住所",
    "pt": " Endereço",
    "ru": "Адрес",
    "sv": "Adress",
    "zh": "地址",
    "ko": "주소"
  },
  "An error occured:": {
    "de": "Ein Fehler ist aufgetreten:",
    "es": "Ha ocurrido un error",
    "fr": "Une erreur s'est produite:",
    "it": "Si è verificato un errore",
    "jp": "エラー発生",
    "pt": "Ocorreu um erro:",
    "ru": "слутчиласъ ошибка",
    "sv": "Ett fel uppstod",
    "zh": "出现错误",
    "ko": "에러 발생"
  },
  "Attention": {
    "de": "Zu Händen",
    "es": "Atención",
    "fr": "A l'attention de",
    "it": "Attenzione",
    "jp": "宛先",
    "pt": "Aos cuidados de",
    "ru": "внимание",
    "sv": "Att:",
    "zh": "联系人",
    "ko": "주의"
  },
  "Cancelation Date": {
    "de": "Stornierungsdatum",
    "es": "Fecha de cancelación",
    "fr": "Date d'annulation",
    "it": "Data cancellazione",
    "jp": "キャンセル日",
    "pt": "Data de cancelamento",
    "ru": "дата отмены",
    "sv": "Avbeställningsdatum",
    "zh": "取消日期",
    "ko": "취소날짜",
    "en": "Cancellation Date"
  },
  "Cancelation Reason": {
    "de": "Stornierungs-<br>grund",
    "es": "Motivo de cancelación",
    "fr": "Raison d'annulation",
    "it": "Motivo cancellazione",
    "jp": "キャンセル理由",
    "pt": "Razão do cancelamento",
    "ru": "повод отмены",
    "sv": "Orsak bakom avbeställning",
    "zh": "取消原因",
    "ko": "취소이유",
    "en": "Cancellation Reason"
  },
  "Canceled Items": {
    "de": "Stornierte Items",
    "es": "Productos cancelados",
    "fr": "Articles annulés",
    "it": "Articoli cancellati",
    "jp": "アイテムキャンセル",
    "pt": "Itens cancelados",
    "ru": "изделия отмененны",
    "sv": "Avbeställda objekt",
    "zh": "已取消项目",
    "ko": "취소품목"
  },
  "Cancelled": {
    "de": "Storniert",
    "es": "Cancelado",
    "fr": "Annulé(e)",
    "it": "Cancellato",
    "jp": "オーダーキャンセル",
    "pt": "Cancelado",
    "ru": "Отменённые заказы",
    "sv": "Avebställd",
    "zh": "已取消",
    "ko": "취소 됨",
    "en": "Canceled"
  },
  "Clean Order": {
    "de": "Akzeptiert",
    "es": "Orden limpia",
    "fr": "Commande validée",
    "it": "Azzera ordine",
    "jp": "手配済",
    "pt": "Pedido aceito",
    "ru": "заказ подтверждён",
    "sv": "Korrekt order",
    "zh": "待生产订单",
    "ko": "Clean order"
  },
  "Close": {
    "de": "Schließen",
    "es": "Cerrar",
    "fr": "Fermer",
    "it": "Chiuso",
    "jp": "クローズ",
    "pt": "Fechar",
    "ru": "закрытъ",
    "sv": "Stäng",
    "zh": "关闭",
    "ko": "완료"
  },
  "Comment": {
    "de": "Kommentar",
    "es": "Comentario",
    "fr": "Commentaire(s)",
    "it": "Commento",
    "jp": "コメント",
    "pt": "Comentário",
    "ru": "комментарий",
    "sv": "Kommentarer",
    "zh": "注释",
    "ko": "코멘트",
    "en": "Comment"
  },
  "Comments": {
    "de": "Kommentare",
    "es": "Comentarios",
    "fr": "Commentaire(s)",
    "it": "Commenti",
    "jp": "コメント",
    "pt": "Comentários",
    "ru": "коментарии",
    "sv": "Kommentarer",
    "zh": "注释",
    "ko": "코멘트"
  },
  "Customer Name": {
    "de": "Kunde",
    "es": "Nombre del Cliente",
    "fr": "Nom du client",
    "it": "Nome cliente",
    "jp": "顧客名",
    "pt": "Nome do cliente",
    "ru": "название заказщикa",
    "sv": "Kundens namn",
    "zh": "客户名称",
    "ko": "고객명"
  },
  "Customer Product": {
    "de": "Kundenprodukt",
    "es": "Producto del cliente",
    "fr": "Produit du client",
    "it": "Prodotto del cliente",
    "jp": "(未使用)Customer Product",
    "pt": "Produto do cliente",
    "ru": "продукт заказщика",
    "sv": "Produkt",
    "zh": "客户产品号",
    "ko": "고객제품"
  },
  "Customer Purchase Order": {
    "de": "Kundenauftrag",
    "es": "Orden de compra del cliente",
    "fr": "N° commande client",
    "it": "Ordine d'acquisto",
    "jp": "顧客手配",
    "pt": "Pedido de compra",
    "ru": "номер заказа заказщика",
    "sv": "Kundens inköpsorder",
    "zh": "客户采购订单",
    "ko": "고객구매오더"
  },
  "Customer#": {
    "de": "Kundennummer",
    "es": "Cliente#",
    "fr": "N° client",
    "it": "Cliente#",
    "jp": "顧客番号",
    "pt": "Número do cliente",
    "ru": "номер заказщика",
    "sv": "Kundnummer",
    "zh": "客户编号",
    "ko": "고객번호",
    "en": "Customer No"
  },
  "Delivered": {
    "de": "Geliefert",
    "es": "Entregado",
    "fr": "Livré(e)",
    "it": "Consegnato",
    "jp": "納入",
    "pt": "Entregue",
    "ru": "Доставленные заказы",
    "sv": "Levererad",
    "zh": "已交货",
    "ko": " 납품"
  },
  "Delivery Comment": {
    "de": "Lieferkommentar",
    "es": "Comentario de entrega",
    "fr": "Commentaire pour la livraison",
    "it": "Commenti alla consegna",
    "jp": "納品コメント",
    "pt": "Comentários na entrega",
    "ru": "комментарий про доставке",
    "sv": "Leveranskommentar",
    "zh": "发送注释",
    "ko": "납품 코멘트"
  },
  "Description": {
    "de": "Beschreibung",
    "es": "Descripción",
    "fr": "Description",
    "it": "Descrizione",
    "jp": "製品説明",
    "pt": "Descrição",
    "ru": "наименование",
    "sv": "Beskrivning",
    "zh": "产品描述",
    "ko": "설명"
  },
  "Email": {
    "de": "Email",
    "es": "Correo electrónico",
    "fr": "E-mail",
    "it": "Email",
    "jp": "email",
    "pt": "Email",
    "ru": "электронный aдрес",
    "sv": "Email",
    "zh": "电子邮件地址",
    "ko": "이메일"
  },
  "End Customer": {
    "de": "Endkunde",
    "es": "Cliente final",
    "fr": "Client final",
    "it": "Utente Finale ",
    "jp": "最終需要先",
    "pt": "Cliente final",
    "ru": "заключительный клиент",
    "sv": "Slutkund",
    "zh": "最终客户",
    "ko": "최종고객"
  },
  "Fax": {
    "de": "Fax",
    "es": "Fax",
    "fr": "Fax",
    "it": "Fax",
    "jp": "Fax",
    "pt": "Fax",
    "ru": "факс",
    "sv": "Fax",
    "zh": "传真",
    "ko": "팩스"
  },
  "Fully<br>invoiced": {
    "de": "Komplett in Rechnung<br>gestellt",
    "es": "Facturado<br>completamente",
    "fr": "Entièrement<br>facturé(e)",
    "it": "Completamente<br>fatturato",
    "jp": "完納請求",
    "pt": "Totalmente faturado",
    "ru": "полностью выставлен счет",
    "sv": "Fullständigt faktuerad",
    "zh": "全部出票",
    "ko": "Invoice 완료",
    "en": "Fully<br>Invoiced"
  },
  "fully_invoiced": {
    "de": "Komplett in Rechnung<br>gestellt",
    "es": "Facturado<br>completamente",
    "fr": "Entièrement<br>facturé(e)",
    "it": "Completamente<br>fatturato",
    "jp": "完納請求",
    "pt": "Totalmente faturado",
    "ru": "полностью выставлен счет",
    "sv": "Fullständigt faktuerad",
    "zh": "全部出票",
    "ko": "Invoice 완료",
    "en": "Fully Invoiced"
  },
  "Fully<br>shipped": {
    "de": "Komplett<br>versandt",
    "es": "Enviado<br>completamente",
    "fr": "Entièrement <br> expédié(e)",
    "it": "Completamente<br>spedito",
    "jp": "完納出荷",
    "pt": "Totalmente enviado",
    "ru": "полностью отправлен заказ ",
    "sv": "Fullständigt levererad",
    "zh": "全部发货",
    "ko": "선적완료",
    "en": "Fully<br>Shipped"
  },
  "fully_shipped": {
    "de": "Komplett<br>versandt",
    "es": "Enviado<br>completamente",
    "fr": "Entièrement <br> expédié(e)",
    "it": "Completamente<br>spedito",
    "jp": "完納出荷",
    "pt": "Totalmente enviado",
    "ru": "полностью отправлен заказ ",
    "sv": "Fullständigt levererad",
    "zh": "全部发货",
    "ko": "선적완료",
    "en": "Fully Shipped"
  },
  "HP Contact": {
    "de": "HP Kontakt",
    "es": "Contacto de HP",
    "fr": "Contact HP",
    "it": "Contatto HP",
    "jp": "HPコンタクト",
    "pt": "Contato HP",
    "ru": "ваш контакт HP",
    "sv": "HP Kontakt",
    "zh": "惠普联系人",
    "ko": "HP연락처",
    "en": "HP Contact"
  },
  "HP Order": {
    "de": "HP Auftrag",
    "es": "Pedido HP",
    "fr": "N° commande HP",
    "it": "Numero ordine HP",
    "jp": "HP 手配",
    "pt": "Ordem HP",
    "ru": "номер заказа HP",
    "sv": "HP Order",
    "zh": "惠普订单",
    "ko": "HP 오더"
  },
  "Invoice To": {
    "de": "Rechnungsempfänger",
    "es": "Factura a",
    "fr": "Adresse de facturation",
    "it": "Fattura intestata a ",
    "jp": "請求先",
    "pt": "Fatura para",
    "ru": "Адрес плателъщика",
    "sv": "Fakturera till",
    "zh": "发票地址",
    "ko": "Invoice 수령인"
  },
  "Item": {
    "de": "Artikelnummer",
    "es": "Artículo",
    "fr": "Article",
    "it": "N. articolo",
    "jp": "アイテム",
    "pt": "Item",
    "ru": "Линия",
    "sv": "Artikel",
    "zh": "项目",
    "ko": "품목"
  },
  "Item Status": {
    "de": "Item Status",
    "es": "Estado del producto",
    "fr": "Statut de l'article",
    "it": "Stato articolo",
    "jp": "アイテムステータス",
    "pt": "Status do Item",
    "ru": "статус изделия",
    "sv": "Artikelstatus",
    "zh": "项目状况",
    "ko": "품목상태"
  },
  "Last Delivered": {
    "de": "Letzte Anlieferung",
    "es": "Última entrega",
    "fr": "Dernier article livré",
    "it": "Ultima consegna",
    "jp": "最終納品日",
    "pt": "última entrega",
    "ru": "последняя отгрузка",
    "sv": "Senast levererad",
    "zh": "最后交货",
    "ko": "최종납품"
  },
  "Last Shipped": {
    "de": "Letzter Versand",
    "es": "Último envío",
    "fr": "Dernier article expédié",
    "it": "Ultima spedizione",
    "jp": "最終出荷日",
    "pt": "último envio",
    "ru": " последняя отправка",
    "sv": "Senast skeppad",
    "zh": "最后发货",
    "ko": "최종선적"
  },
  "Loading ...": {
    "de": "Daten werden geladen ...",
    "es": "Cargando...",
    "fr": "Chargement…",
    "it": "Caricamento...",
    "jp": "取り込み中",
    "pt": "A carregar...",
    "ru": "действует",
    "sv": "Laddar...",
    "zh": "正在加载…",
    "ko": "로딩 중…"
  },
  "More Info": {
    "de": "Weitere Informationen",
    "es": "Más información",
    "fr": "Plus d'information",
    "it": "Maggiori informazioni",
    "jp": "情報詳細",
    "pt": "Mais informações",
    "ru": "больше информации",
    "sv": "Mer information",
    "zh": "更多信息",
    "ko": "상세정보"
  },
  "Most recent event dates of your order": {
    "de": "Die letzten Änderungen auf ihrer Bestellung",
    "es": "Fechas de eventos más recientes de su orden",
    "fr": "Dates des événements les plus récents de votre commande",
    "it": "Date degli eventi più recenti del vostro ordine",
    "jp": "最新更新日",
    "pt": "Datas de eventos mais recentes de sua ordem",
    "ru": "Последние события даты вашего заказа",
    "sv": "Senaste händelse datum för din beställning",
    "zh": "最近发生在您订单上的事件日期",
    "ko": "가장 최근의 오더 상태변경 날짜"
  },
  "Multiple orders found": {
    "de": "Mehrere Aufträge gefunden",
    "es": "Múltiples órdenes encontradas",
    "fr": "Plusieurs commandes trouvées",
    "it": "Ordini trovati",
    "jp": "複数手配があります",
    "pt": "Várias ordens encontradas",
    "ru": "найдено несколько заказов ",
    "sv": "Flera ordrar funna",
    "zh": "发现多个订单",
    "ko": "여러개의 오더 조회됨"
  },
  "NO_ORDER_FOUND": {
    "de": "Auftrag nicht gefunden",
    "es": "Ningún pedido encontrado",
    "fr": "Aucune commande trouvée",
    "it": "Nessun ordine trovato",
    "jp": "該当手配がありません",
    "pt": "PEDIDO_NAO_ENCONTRADO",
    "ru": "найдено никакого заказа",
    "sv": "Ingen order funnen",
    "zh": "没有找到订单",
    "ko": "해당하는 오더 없음",
    "en": "The order reference could not be found"
  },
  "Nothing<br>invoiced": {
    "de": "Nichts in Rechnung gestellt",
    "es": "No<br>Facturado",
    "fr": "Aucune<br>facturation",
    "it": "Non<br>fatturato",
    "jp": "未請求",
    "pt": "Não faturado",
    "ru": "счёт не выписанный",
    "sv": "Inget fakturerat",
    "zh": "未出票",
    "ko": "Invoice 발행안됨",
    "en": "Nothing<br>Invoiced"
  },
  "nothing_invoiced": {
    "de": "Nichts in Rechnung gestellt",
    "es": "No<br>Facturado",
    "fr": "Aucune<br>Facturation",
    "it": "Non<br>fatturato",
    "jp": "未請求",
    "pt": "Não faturado",
    "ru": "счёт не выписанный",
    "sv": "Inget fakturerat",
    "zh": "未出票",
    "ko": "Invoice 발행안됨",
    "en": "Nothing Invoiced"
  },
  "Nothing<br>shipped": {
    "de": "Nichts versendet",
    "es": "No<br>Enviado",
    "fr": "Aucune<br>expédition",
    "it": "Non<br>spedito",
    "jp": "未出荷",
    "pt": "Não enviado",
    "ru": "никакой отправки",
    "sv": "Inget skeppat",
    "zh": "未发货",
    "ko": "선적 없음",
    "en": "Nothing<br>Shipped"
  },
  "nothing_shipped": {
    "de": "Nichts versendet",
    "es": "No<br>Enviado",
    "fr": "Aucune<br>expédition",
    "it": "Non<br>spedito",
    "jp": "未出荷",
    "pt": "Não enviado",
    "ru": "никакой отправки",
    "sv": "Inget skeppat",
    "zh": "未发货",
    "ko": "선적 없음",
    "en": "Nothing Shipped"
  },
  "Open Items": {
    "de": "Offene Items",
    "es": "Productos por enviar",
    "fr": "Produits non-expédiés",
    "it": "Articoli aperti",
    "jp": "手配済みアイテム",
    "pt": "Itens abertos",
    "ru": "Не выполненные позиции",
    "sv": "Öppna artiklar",
    "zh": "未发货项目",
    "ko": "오픈 품목"
  },
  "Order": {
    "de": "Auftrag",
    "es": "Orden",
    "fr": "Commande",
    "it": "Ordine",
    "jp": "手配",
    "pt": "Pedido",
    "ru": "заказ",
    "sv": "Order",
    "zh": "订单",
    "ko": "오더"
  },
  "Order Details": {
    "de": "Auftragsdetails",
    "es": "Detalle de la orden",
    "fr": "Détail de la commande",
    "it": "Dettagli ordine",
    "jp": "手配詳細",
    "pt": "Detalhes do pedido",
    "ru": "детали заказа",
    "sv": "Orderdetaljer",
    "zh": "订单详情",
    "ko": "오더 상세내역"
  },
  "Order Qty": {
    "de": "Bestellmenge",
    "es": "Cantidad de la orden",
    "fr": "Qté commandée",
    "it": " Quantita’ ordine",
    "jp": "手配個数",
    "pt": "Quantitade",
    "ru": "Заказанное количество",
    "sv": "Kvantitet",
    "zh": "订货量",
    "ko": "오더 수량",
    "nl": "Aantal",
    "en": "Order Quantity"
  },
  "Order Type": {
    "de": "Auftragsart",
    "es": "Tipo de orden",
    "fr": "Type de commande",
    "it": "Tipo di ordine",
    "jp": "オーダータイプ",
    "pt": "Tipo do pedido",
    "ru": "вид заказа",
    "sv": "Typ av order",
    "zh": "订单类型",
    "ko": "오더 종류"
  },
  "Order Value (incl.Tax)": {
    "de": "Preis (inkl. Mwst)",
    "es": "Valor de la orden (tasas incluidas)",
    "fr": "Montant de la commande (taxes incl.)",
    "it": "Valore Ordine (iva incl.)",
    "jp": "手配金額（税込み）",
    "pt": "Valor do pedido (com impostos)",
    "ru": "стоймость заказа (вкл. налоги)",
    "sv": "Ordervärde (incl. Moms)",
    "zh": "订单金额 (含税)",
    "ko": "오더 금액(부가세포함)"
  },
  "Partial Qty": {
    "de": "Teilmenge",
    "es": "Cantidad Parcial",
    "fr": "Quantité partielle",
    "it": "Qty parziale",
    "jp": "分納個数",
    "pt": "Qty parcial",
    "ru": "Частичный объем",
    "sv": "Partiell Kvt",
    "zh": "部分发货数量",
    "ko": "부분 수량",
    "en": "Partial Quantity"
  },
  "Partially<br>invoiced": {
    "de": "Teilweise in Rechnung<br>gestellt",
    "es": "Facturado<br>Parcialmente",
    "fr": "Partiellement<br>facturé(e)",
    "it": "Parzialmente<br>fatturato",
    "jp": "分納請求",
    "pt": "Parcialmente faturado",
    "ru": "частичный счет",
    "sv": "Delvis<br>fakturerad",
    "zh": "部分出票",
    "ko": "Invoice 부분완료",
    "en": "Partially<br>Invoiced"
  },
  "partially_invoiced": {
    "de": "Teilweise in Rechnung<br>gestellt",
    "es": "Facturado<br>Parcialmente",
    "fr": "Partiellement<br>facturé(e)",
    "it": "Parzialmente<br>fatturato",
    "jp": "分納請求",
    "pt": "Parcialmente faturado",
    "ru": "частичный счет",
    "sv": "Delvis<br>fakturerad",
    "zh": "部分出票",
    "ko": "Invoice 부분완료",
    "en": "Partially Invoiced"
  },
  "Partially<br>shipped": {
    "de": "Teilweise<br>versandt",
    "es": "Enviado<br>Parcialmente",
    "fr": "Partiellement<br>expédié(e)",
    "it": "Parzialmente <br> spedito",
    "jp": "分納出荷",
    "pt": "Parcialmente faturado",
    "ru": "частичная отправка",
    "sv": "Delvis skeppad",
    "zh": "部分发货",
    "ko": "부분 선적",
    "en": "Partially<br>Shipped"
  },
  "partially_shipped": {
    "de": "Teilweise<br>versandt",
    "es": "Enviado<br>Parcialmente",
    "fr": "Partiellement<br>expédié(e)",
    "it": "Parzialmente <br> spedito",
    "jp": "分納出荷",
    "pt": "Parcialmente faturado",
    "ru": "частичная отправка",
    "sv": "Delvis skeppad",
    "zh": "部分发货",
    "ko": "부분 선적",
    "en": "Partially Shipped"
  },
  "Phone": {
    "de": "Telefon",
    "es": "Teléfono",
    "fr": "Téléphone",
    "it": "Telefono",
    "jp": "電話",
    "pt": "Telefone",
    "ru": "Телефон",
    "sv": "Telefon",
    "zh": "电话号码",
    "ko": "전화번호"
  },
  "Planned Delivery Date": {
    "de": "Geplantes Lieferdatum",
    "es": "Fecha prevista de entrega",
    "fr": "Date de livraison prévue",
    "it": "Data di consegna pianificata",
    "jp": "納入予定日",
    "pt": "Data de entrega estimada",
    "ru": "планируемая дата доставки",
    "sv": "Planerat leveransdatum",
    "zh": "预计交货日期",
    "ko": "납품예정일",
    "nl": "Geplande leveringsdatum"
  },
  "Planned Ship Date": {
    "de": "Geplantes Versanddatum",
    "es": "Fecha prevista de envío",
    "fr": "Date d'expédition prévue",
    "it": "Data di spedizione pianificata",
    "jp": "出荷予定日",
    "pt": "Data planejada de envio",
    "ru": "планируемая дата отправки",
    "sv": "Planerat skeppningsdatum",
    "zh": "预计发货日期",
    "ko": "선적예정일"
  },
  "Please select": {
    "de": "Bitte wählen Sie",
    "es": "Por favor seleccione",
    "fr": "Veuillez sélectionner",
    "it": "Per favore scegliere",
    "jp": "選択ください",
    "pt": "Por favor seleccione",
    "ru": "отберите пожалуйста",
    "sv": "Vänligen välj",
    "zh": "请选择",
    "ko": "선택하세요"
  },
  "Processing": {
    "de": "In Bearbeitung",
    "es": "En proceso",
    "fr": "En cours de traitement",
    "it": "In processo",
    "jp": "処理中",
    "pt": "A processar",
    "ru": "действует",
    "sv": "Bearbetar",
    "zh": "正在处理",
    "ko": "진행중"
  },
  "Product": {
    "de": "Produkt",
    "es": "Descripción de producto",
    "fr": "Produit",
    "it": "Prodotto",
    "jp": "製品",
    "pt": "Produto",
    "ru": "продукт",
    "sv": "Produkt",
    "zh": "产品",
    "ko": "제품"
  },
  "Production": {
    "de": "Produktion",
    "es": "Producción",
    "fr": "En production",
    "it": "Produzione",
    "jp": "製造",
    "pt": "Producção",
    "ru": "в стадии производства",
    "sv": "Produktion",
    "zh": "在生产中",
    "ko": "생산 준비 및 생산"
  },
  "Puchase Order Date": {
    "de": "Kundenauftragsdatum",
    "es": "Fecha de pedido de compra",
    "fr": "Date de commande",
    "it": "Data acquisto ordine",
    "jp": "注文日",
    "pt": "Data da encomenda",
    "ru": "дата заказа",
    "sv": "Inköpsorder datum",
    "zh": "采购订单日期",
    "ko": "발주날짜",
    "en": "Purchase Order Date"
  },
  "Purchase Agent": {
    "de": "Auftraggeber",
    "es": "Agente de compras",
    "fr": "Agent d'achat",
    "it": "Supporto all'acquisto",
    "jp": "Purchase Agent",
    "pt": "Agente da compra",
    "ru": "заказивающое лицо",
    "sv": "Inköpsagent",
    "zh": "采购代理",
    "ko": "구매 대리인"
  },
  "Purchase Agreement": {
    "de": "Vertragsnummer",
    "es": "Acuerdo de compra",
    "fr": "Numéro d'agrément",
    "it": "Contratto d'acquisto",
    "jp": "ご契約",
    "pt": "Acordo de compra",
    "ru": " Договор",
    "sv": "Köpeavtal",
    "zh": "采购协议",
    "ko": "구매 계약"
  },
  "Purchase Order": {
    "de": "Auftragsnummer",
    "es": "Orden de compra",
    "fr": "N° commande",
    "it": "Ordine d'acquisto",
    "jp": "ご注文",
    "pt": "Encomenda",
    "ru": "номер заказа",
    "sv": "Inköpsorde",
    "zh": "采购订单",
    "ko": "구매 오더"
  },
  "Purchased": {
    "de": "Bestellt",
    "es": "Comprado",
    "fr": "Acheté(e)(s)",
    "it": "Acquistato",
    "jp": "Purchased",
    "pt": "Recebido",
    "ru": "купленный ",
    "sv": "Köpt",
    "zh": "已采购",
    "ko": "구매 됨"
  },
  "Quote No": {
    "en": "Quote No",
    "de": "Angebot",
    "es": "Número de cotización",
    "fr": "N° de Devis",
    "it": "Nr quotazione",
    "jp": "見積番号",
    "pt": "N° Cotação",
    "ru": "номер ценового предложения",
    "sv": "Kostnadsförslag",
    "zh": "报价编号",
    "ko": "견적번호"
  },
  "Requested": {
    "de": "Gewünscht",
    "es": "Pedido",
    "fr": "Demandé(e)",
    "it": "Richiesto",
    "jp": "Requested",
    "pt": "Pedido",
    "ru": "требуемый",
    "sv": "Efterfrågat",
    "zh": "已要求",
    "ko": "요청 됨"
  },
  "Requested Date": {
    "de": "Gewünschter Termin",
    "es": "Fecha solicitada",
    "fr": "Date demandée",
    "it": "Data richiesta",
    "jp": "ご要求納期",
    "pt": "Data solicitada",
    "ru": "желаемая дата",
    "sv": "Begärt datum",
    "zh": "客户要求交货日期",
    "ko": "고객 요청 날짜",
    "en": "Customer Requested Date"
  },
  "Ship To": {
    "de": "Lieferempfänger",
    "es": "Envío a",
    "fr": "Adresse de livraison",
    "it": "Spedito a",
    "jp": "納品先",
    "pt": "Enviado para",
    "ru": "Адрес доставки",
    "sv": "Skeppningsadress",
    "zh": "送货地址",
    "ko": "배송지"
  },
  "Shipped": {
    "de": "Versendet",
    "es": "Embarcado",
    "fr": "Expédié(e)",
    "it": "Spedito",
    "jp": "出荷",
    "pt": "Enviados",
    "ru": "отправлено",
    "sv": "Levereras",
    "zh": "已发货",
    "ko": "선적 됨"
  },
  "Shipped Items": {
    "de": "Versendete Items",
    "es": "Artículos enviados",
    "fr": "Produits expédiés",
    "it": "Articoli spediti",
    "jp": "出荷済みアイテム",
    "pt": "Itens enviados",
    "ru": "отправленные  позиции",
    "sv": "Skeppade artiklar",
    "zh": "已发货项目",
    "ko": "선적 품목"
  },
  "Shipped Qty": {
    "de": "Versendete Menge",
    "es": "Cantidad Enviada",
    "fr": "Qté expédiée",
    "it": "Q.tà spedita",
    "jp": "出荷済み個数",
    "pt": "Qtd enviadas",
    "ru": "отправленное колитчество",
    "sv": "Antal skeppade artiklar",
    "zh": "发货数量",
    "ko": "선적 수량",
    "en": "Shipped Quantity"
  },
  "Shipped to Customer": {
    "de": "Versendet",
    "es": "Enviado al cliente",
    "fr": "Expédié(e)(s) chez le client",
    "it": "Spedito al Cliente",
    "jp": "出荷",
    "pt": "Enviado para o cliente",
    "ru": "отправлён к грузополучателъю",
    "sv": "Skeppade till kund",
    "zh": "已发货",
    "ko": "공장 출하"
  },
  "Sold To": {
    "de": "Käufer",
    "es": "Vendido a",
    "fr": "Adresse de l'acheteur",
    "it": "Venduto a",
    "jp": "契約先",
    "pt": "Vendido a",
    "ru": "Адрес Заказшика",
    "sv": "Såld till",
    "zh": "客户地址",
    "ko": "판매지"
  },
  "Submitted": {
    "de": "Eingereicht",
    "es": "Recibido",
    "fr": "Enregistré(e)",
    "it": "Processato",
    "jp": "ご注文受領",
    "pt": "Submetido",
    "ru": "Посланный",
    "sv": "Beställd",
    "zh": "采购订单提交",
    "ko": "발주서 수령"
  },
  "This reflects the status of the longest lead time item on your order": {
    "de": "Dies bezeichnet den Artikel mit der längsten Lieferzeit aus Ihrer Bestellung",
    "es": "Este artículo es el de mayor tiempo de entrega de su pedido",
    "fr": "Ceci représente le statut de l'article dont le délai est le plus long sur votre commande",
    "it": "Il prodotto del vs. ordine ha il più lungo tempo di consegna",
    "jp": "最長納期アイテムのステータスを反映",
    "pt": "Reflete o status do item com tempo para entrega mais longo em seu pedido ",
    "ru": "Это самая поздняя по производству позиция в вашем заказе ",
    "sv": "Detta representerar artikeln med längst leveranstid på din beställning",
    "zh": "这表示您订单上交货期最长的项目",
    "ko": "해당오더 품목의 최장 리드타임을 표시함"
  },
  "This represents the shortest lead time item on your order": {
    "de": "Dies bezeichnet den Artikel mit der kürzesten Lieferzeit aus Ihrer Bestellung",
    "es": "Esto representa el artículo de menor tiempo de entrega de su pedido",
    "fr": "Ceci représente le statut de l'article dont le délai est le plus court sur votre commande",
    "it": "Il prodotto del vs. ordine ha il più corto tempo di consegna",
    "jp": "最短納期アイテムのステータスを反映",
    "pt": "Este representa o item de menor tempo de espera na sua encomenda",
    "ru": "Это самая ранняя по производству позиция в вашем заказе",
    "sv": "Detta representerar artikeln med kortast leveranstid på din beställning",
    "zh": "这表示您订单上交货期最短的项目",
    "ko": "해당오더 품목의 최단 리드타임을 표시함"
  },
  "Business Unit": {
    "de": "Geschäftsbereich",
    "es": "Unidad de negocio",
    "fr": "Branche d'activité",
    "it": "Business Unit",
    "jp": "ビジネスユニット",
    "pt": "BU",
    "ru": "Подразделение",
    "sv": "Business unit",
    "zh": "业务单位",
    "ko": "Business Unit"
  },
  "Carrier": {
    "de": "Spediteur",
    "es": "Transportista",
    "fr": "Transporteur",
    "it": " Nome del corriere",
    "jp": "納品業者",
    "pt": " Transportador",
    "ru": "Перевозчик",
    "sv": "Speditör",
    "zh": "承运商",
    "ko": "물류업체"
  },
  "Currency": {
    "de": "Währung",
    "es": "Moneda",
    "fr": "Devise",
    "it": "Valuta",
    "jp": "通貨",
    "pt": "Moeda",
    "ru": "Валюта",
    "sv": "Valuta",
    "zh": " 币种",
    "ko": "통화"
  },
  "Customer Notes": {
    "de": "HP Zusatzinformationen",
    "es": "Comentario HP",
    "fr": "Notes d' HP",
    "it": " Commenti del cliente",
    "jp": "顧客向けコメント",
    "pt": " Notas HP",
    "ru": "отметки заказщика",
    "sv": "Kund kommentar",
    "zh": "客户注释",
    "ko": "고객의 요청사항",
    "en": "HP Notes"
  },
  "Customer Product Number": {
    "de": "Artikelnummer des Kunden",
    "es": "Número de produto del cliente",
    "fr": "N° de produit client",
    "it": "Numero prodotto del cliente",
    "jp": "顧客製品番号",
    "pt": "Número de produto",
    "ru": "Номер Продукта",
    "sv": "Kundens produktnummer",
    "zh": "客户产品号",
    "ko": "고객 제품번호"
  },
  "Customer Requested Date": {
    "de": "Gewünschter Liefertermin",
    "es": "Fecha solicitada por el cliente",
    "fr": "Date demandée",
    "it": "Data richiesta di consegna",
    "jp": "ご要求納期",
    "pt": "Data solicitada",
    "ru": "Запрашиваемая дата поставки",
    "sv": "Begärt datum",
    "zh": "客户要求交货日期",
    "ko": "고객 요청일"
  },
  "Days Since HP Received": {
    "de": "Tage seit Auftragseingang",
    "es": "Días desde envío a HP",
    "fr": "Nombre de jours depuis la réception de la commande",
    "it": " Giorni passati dal ricevimento dell’ordine",
    "jp": "HP受領後の経過日数",
    "pt": " Dias dede a recepção ",
    "ru": "Kоличество дней с момента поступления заказа",
    "sv": "Dagar sedan beställning",
    "zh": "惠普收到订单的天数",
    "ko": "발주 접수부터 현재까지의 기간"
  },
  "HP Customer Number": {
    "de": "HP Kundennummer",
    "es": "Número de cliente HP",
    "fr": "N° client HP",
    "it": "Numero HP del cliente",
    "jp": "HP顧客番号",
    "pt": "Número de cliente HP",
    "ru": "Идентфикационный Номер Клиента",
    "sv": "HP kundnummer",
    "zh": "惠普客户编号",
    "ko": "HP 고객번호"
  },
  "HP Receive Date": {
    "de": "Datum des Auftragseingangs bei HP",
    "es": "Fecha de recepción del pedido",
    "fr": "Date de réception de la commande",
    "it": "Data ricevimento ordine",
    "jp": "ご注文書入手日",
    "pt": "Data de recepção do pedido",
    "ru": "Дата поступления заказа",
    "sv": "Inkommet till HP",
    "zh": "惠普收到日期",
    "ko": "HP 접수날짜"
  },
  "Invoice Date": {
    "de": "Rechnungsdatum",
    "es": "Fecha de facturación",
    "fr": "Date de facturation",
    "it": "Data fattura",
    "jp": "ご請求日",
    "pt": " Data de faturação",
    "ru": "Дата счет-фактуры",
    "sv": "Fakturadatum",
    "zh": "发票日期",
    "ko": "Invoice 발행날짜"
  },
  "Invoice No": {
    "de": "Rechnungsnummer",
    "es": "Factura#",
    "fr": "N° de facture",
    "it": "No. fattura",
    "jp": "ご請求番号",
    "pt": "Número de fatura",
    "ru": "Номер счёт-фактуры",
    "sv": "Fakturanummer",
    "zh": "发票号",
    "ko": "Invoice 번호"
  },
  "Item Number": {
    "de": "Item Number",
    "es": "Número de producto",
    "fr": "Article",
    "it": "Articolo",
    "jp": "アイテム",
    "pt": "Item",
    "ru": "Номер позиции",
    "sv": "Artikel",
    "zh": "项目",
    "ko": "품목 번호"
  },
  "Net Line Price": {
    "de": "Nettopreis",
    "es": "Precio neto por linea",
    "fr": "Prix net de l'article",
    "it": "Prezzo netto",
    "jp": "値引き後価格",
    "pt": "Preço por linha sem impostos",
    "ru": "Цена нетто",
    "sv": "Nettopris",
    "zh": "订单单项价格",
    "ko": "단가"
  },
  "Opportunity ID": {
    "de": "Opportunity Nr",
    "es": "ID de oportunidad",
    "fr": "N° preavis",
    "it": "Numero Opportunita'",
    "jp": "Opportunity ID",
    "pt": "ID de oportunidade",
    "ru": "Opportunity ID",
    "sv": "OPG",
    "zh": "Opportunity ID",
    "ko": "Opportunity ID"
  },
  "Product Line Code": {
    "de": "Produktlinie",
    "es": "Código de linea de producto",
    "fr": "Code de la ligne de produit",
    "it": "Codifica Product Line",
    "jp": "Product Lineコード",
    "pt": "Código de linha de produto",
    "ru": "Код Продуктовой Линейки",
    "sv": "Produktlinje kod",
    "zh": "产品线编号",
    "ko": "제품라인 코드"
  },
  "Product Line Description": {
    "de": "Produktlinienbezeichnung",
    "es": "Descripcion linea de producto",
    "fr": "Description de la ligne de produit",
    "it": "Descrizione Product Line",
    "jp": "Product Line内容",
    "pt": "Descrição de linha de produto",
    "ru": "Описание Продуктовой Линейки",
    "sv": "Produktlinje beskrivning",
    "zh": "产品线描述",
    "ko": "제품 라인 내용"
  },
  "Product Description": {
    "de": "Produktbezeichnung",
    "es": "Descripción del producto",
    "fr": "Description du produit",
    "it": "Descrizione prodotto",
    "jp": "製品内容",
    "pt": "Descrição do produto",
    "ru": "Наименование товара",
    "sv": "Produktbeskrivning",
    "zh": " 产品描述",
    "ko": "제품 설명",
    "nl": "Beschrijving"
  },
  "Product Number": {
    "de": "Produkt Nr",
    "es": "Nº de producto",
    "fr": "N° produit",
    "it": "No. prodotto",
    "jp": "製品番号",
    "pt": "Número de produto",
    "ru": "Номер продукта",
    "sv": "Produktnummer",
    "zh": "产品号",
    "ko": "제품 번호",
    "nl": "Productnr.  "
  },
  "Ship To Country": {
    "de": "Versandland",
    "es": "Pais de entrega",
    "fr": "Pays de livraison",
    "it": "Paese di spedizione  ",
    "jp": "出荷先国",
    "pt": " País de destino",
    "ru": "Страна Отгрузки",
    "sv": "Produktlinje beskrivning",
    "zh": "发货国家",
    "ko": "배송국가"
  },
  "POD Date": {
    "de": "Lieferdatum",
    "es": "Fecha del comprobante de envío",
    "fr": "Date de livraison",
    "it": "Data bolla di consegna",
    "jp": "納品日",
    "pt": "  Data de entrega",
    "ru": "Дата подписания документа о получении / POD",
    "sv": "POD datum",
    "zh": "签收日期",
    "ko": "인수 날짜",
    "en": "POD Date"
  },
  "Purchase Order Date": {
    "de": "Bestelldatum",
    "es": "Fecha del pedido",
    "fr": "Date de la commande client",
    "it": " Data dell’ordine d'acquisto",
    "jp": "注文日",
    "pt": " Data do pedido",
    "ru": "Дата заказа Партнёра",
    "sv": "PO Datum",
    "zh": "采购订单日期",
    "ko": "구매 오더 날짜"
  },
  "Purchase Order No": {
    "de": "Bestellnummer",
    "es": "Número del pedido de compra",
    "fr": "N° commande client",
    "it": "Numero ordine d'acquisto",
    "jp": "ご注文番号",
    "pt": "Número de ordem de compra",
    "ru": "Номер заказа Партнёра",
    "sv": "PO Nummer",
    "zh": "采购订单号",
    "ko": "구매 오더 번호"
  },
  "SAP Order No": {
    "de": "SAP Auftrags Nr",
    "es": "Número del pedido SAP",
    "fr": "N° commande SAP",
    "it": "Numero ordine SAP",
    "jp": "社内手配番号",
    "pt": "Número de pedido SAP",
    "ru": "Внутренний номер заказа",
    "sv": "SAP ordernummer",
    "zh": "SAP订单号",
    "ko": "SAP 오더번호"
  },
  "Scheduled Ship Date": {
    "de": "Geplantes Versanddatum",
    "es": "Fecha programada de salida",
    "fr": "Date d'expédition prévue",
    "it": "Data di spedizione pianificata",
    "jp": "出荷予定日",
    "pt": "Data planejada de envio",
    "ru": "Планируемая дата отгрузки",
    "sv": "Planerat skeppdatum",
    "zh": "预计发货日期",
    "ko": "선적예정일",
    "en": "Planned Ship Date"
  },
  "Scheduled Delivery Date": {
    "de": "Geplantes Lieferdatum",
    "es": "Fecha programada de entrega",
    "fr": "Date de livraison prévue",
    "it": "Data di consegna pianificata",
    "jp": "納入予定日",
    "pt": " Data planejada de entrega",
    "ru": "Планируемая дата поставки",
    "sv": "Planerat leveransdatum",
    "zh": "预计交货日期",
    "ko": "납품예정일",
    "en": "Planned Delivery Date"
  },
  "Ship Status": {
    "de": "Versandstatus",
    "es": "Estatus del envío",
    "fr": "Statut de l'expédition",
    "it": "Status spedizione",
    "jp": "出荷ステータス",
    "pt": "Estado do envio",
    "ru": "Статус Отгрузки",
    "sv": "Skeppstatus",
    "zh": "发货状态",
    "ko": "선적 상태"
  },
  "Sold To Country": {
    "de": "Verkaufsland",
    "es": "Pais de venta",
    "fr": "Pays de l'acheteur",
    "it": "Paese di destinazione",
    "jp": "購入国",
    "pt": "País de venda",
    "ru": "Продажа в страну",
    "sv": "Sålt till land",
    "zh": "发货国家",
    "ko": "구매국가"
  },
  "Status": {
    "de": "Status",
    "es": "Estatus",
    "fr": "Statut",
    "it": "Status",
    "jp": "ステータス",
    "pt": "Estado",
    "ru": "Статус",
    "sv": "Status",
    "zh": "状态",
    "ko": "현황",
    "nl": "Status  "
  },
  "Summarized Status": {
    "de": "Gesamtstatus",
    "es": "Estado general del pedido ",
    "fr": "Statut consolidé",
    "it": " Status generale dell’ordine",
    "jp": "ステータスサマリ",
    "pt": " Resumo do estado",
    "ru": "Общий статус заказа",
    "sv": "Sammanfattande Status",
    "zh": "总体状态",
    "ko": "현황요약"
  },
  "SAP Order #": {
    "de": "SAP Auftrags Nr",
    "es": "Número del pedido SAP",
    "fr": "\tN° commande SAP",
    "it": "Numero ordine SAP",
    "jp": "社内手配番号",
    "pt": "  Número de pedido SAP",
    "ru": "Внутренний номер заказа",
    "sv": "SAP ordernummer",
    "zh": "SAP订单号",
    "ko": "SAP 오더번호",
    "en": "SAP Order No"
  },
  "ship_to_attn": {
    "en": "Ship To Name",
    "de": "Lieferungsempfänger",
    "es": "Contacto en la entrega",
    "fr": "Destinataire / A l'attention de ",
    "it": "Contatto per la consegna",
    "jp": "宛先",
    "pt": " Contacto para a entrega",
    "ru": "Контактное лицо  грузополучателя",
    "sv": "Kontaktnamn",
    "zh": " 收货方名称",
    "ko": "배송 담당자"
  },
  "ship_to_addr_1": {
    "en": "Ship To Address",
    "de": "Lieferaddresse",
    "es": "Dirección de entrega",
    "fr": "Adresse de livraison",
    "it": " Indirizzo di consegna",
    "jp": "出荷先",
    "pt": " Morada de envio",
    "ru": "Адрес грузополучателя",
    "sv": "Skeppningsadress",
    "zh": "收货方地址",
    "ko": "배송 주소"
  },
  "Ship Date": {
    "de": "Lieferdatum",
    "es": "Fecha actual de salida",
    "fr": "Date d'expédition",
    "it": "Data di spedizione",
    "jp": "出荷日",
    "pt": " Data de envio",
    "ru": "Фактическая дата отгрузки",
    "sv": "Skeppningsdatum",
    "zh": "发货日期",
    "ko": "출고 날짜",
    "en": "Actual Ship Date"
  },
  "submittedOrders": {
    "en": "Total placed",
    "de": "Gesamt plaziert",
    "fr": "Commande(s) transmise(s)",
    "ko": "제출된 오더",
    "jp": "受注済み",
    "it": " Ordini sottomessi",
    "pt": " Total Colocado",
    "ru": "Всего размещено",
    "zh": "已提交订单",
    "sv": "Totalt",
    "es": "Total procesado"
  },
  "openOrders": {
    "en": "Open",
    "de": "Offene Aufträge",
    "fr": "Commande(s) ouverte(s) ",
    "ko": "오픈 오더",
    "jp": "出荷前",
    "it": " Ordini aperti",
    "pt": " Abertos",
    "ru": "Открытые заказы",
    "zh": "待生产订单",
    "sv": "Öppna",
    "es": "Abierto"
  },
  "shippedOrders": {
    "en": "Shipped",
    "de": "Versendet",
    "fr": "Commande(s) expédiée(s)",
    "ko": "출고 오더",
    "jp": "工場出荷済み",
    "it": " Ordini spediti",
    "pt": " Enviados",
    "ru": "Отгруженные заказы",
    "zh": "已发货订单",
    "sv": "Skeppade",
    "es": "Enviado"
  },
  "deliveredOrders": {
    "en": "Delivered",
    "de": "Geliefert",
    "fr": "Commande(s) livrée(s)",
    "ko": "납품 오더",
    "jp": "納品済み",
    "it": " Ordini consegnati",
    "pt": " Entregues",
    "ru": "Доставленные заказы",
    "zh": "已送达订单",
    "sv": "Levererade",
    "es": "Entregado"
  },
  "cancelledOrders": {
    "en": "Cancelled",
    "de": "Storniert",
    "fr": "Commande(s) annulée(s)",
    "ko": "취소 오더",
    "jp": "キャンセル済み",
    "it": " Ordini cancellati",
    "pt": " Cancelados",
    "ru": "Отменённые заказы",
    "zh": "已取消订单",
    "sv": "Inställd",
    "es": "Cancelado"
  },
  "Overview of your recent orders": {
    "en": "Overview of your recent orders",
    "de": "Übersicht Ihrer letzten Aufträge",
    "fr": "Résumé de vos commandes récentes",
    "ko": "최근 오더 요약",
    "jp": "直近オーダーサマリ",
    "it": "Situazione dei vostri ordini piu' recenti",
    "pt": "Visão geral das encomendas recentes",
    "ru": "Информация о ваших недавних заказах",
    "zh": "您近期订单总汇",
    "sv": "Översikt av senaste ordrar",
    "es": "Resumen de pedidos recientes"
  },
  "Search your orders": {
    "en": "Search your orders",
    "de": "Auftragssuche",
    "fr": "Recherchez vos commandes",
    "ko": "오더 조회",
    "jp": "手配検索",
    "it": "Ricerca I suoi ordini",
    "pt": "Procure seus pedidos",
    "ru": "Поиск заказов",
    "zh": "搜索您的订单",
    "sv": "Sök ordrar",
    "es": "Búsqueda de pedidos"
  },
  "searchID": {
    "en": "Search Value",
    "de": "Suchkriterium",
    "fr": "Recherche",
    "ko": "검색 값",
    "jp": "ID検索",
    "it": "ricerca ID",
    "pt": "Referência de procura",
    "ru": "Поисковый ID",
    "zh": "搜索值",
    "sv": "Sök ID",
    "es": "ID de búsqueda"
  },
  "searchHint": {
    "en": "Customer PO / HP Order / Shipment / Tracking / Invoice No",
    "de": "Kundenauftrags Nr / HP Auftrags Nr / Lieferungs Nr / Rechnungs Nr",
    "fr": "N° commande client / N° commande HP / N° commande web / N° de suivi colis / N° de facture",
    "ko": "고객구매오더번호/HP 오더번호/선적번호/운송번호/Invoice번호",
    "jp": "注文書番号/HP手配番号/出荷No./トラッキングNo./請求書番号",
    "it": "Suggerimento Ricerca",
    "pt": "Sugestão de procura",
    "ru": "Подсказка по Поиску",
    "zh": "客户采购单号/惠普订单号/发货号/跟踪号/发票号",
    "sv": "Customer PO / HP Order / Shipment / Tracking / Invoice No",
    "es": "Buscar por"
  },
  "Date Range": {
    "en": "Date Range",
    "de": "Datumsbereich",
    "fr": "Plage de date",
    "ko": "날짜 범위",
    "jp": "日付検索",
    "it": "Data intervallo",
    "pt": "Intervalo de datas",
    "ru": "Промежуток Времени",
    "zh": "日期区间",
    "sv": "Datumintervall",
    "es": "Rango de fecha"
  },
  "Select Date Type": {
    "en": "",
    "de": "Datumstyp",
    "fr": "Selectionnez le type de date",
    "ko": "날짜 형식 선택",
    "jp": "日付形式選択",
    "it": "Selezionate Data Type",
    "pt": "Selecionar Tipo de Data",
    "ru": "Выбрать Формат Даты",
    "zh": "选择日期类型",
    "sv": "Välj datumformat",
    "es": "Seleccionar tipo de fecha"
  },
  "dateRangeHint": {
    "en": "YYYY-MM-DD to YYYY-MM-DD",
    "de": "YYYY-MM-DD bis YYYY-MM-DD",
    "fr": "YYYY-MM-DD à YYYY-MM-DD",
    "ko": "년월일부터 년월일까지",
    "jp": "YYYY-MM-DD to YYYY-MM-DD",
    "it": "Data intervallo suggerimento",
    "pt": "Sugestão de Intervalo de datas",
    "ru": "Подсказка по Промежутку Времени",
    "zh": "YYYY-MM-DD 至 YYYY-MM-DD",
    "sv": "YYYY-MM-DD to YYYY-MM-DD",
    "es": "Sugerencia de intervalo de fechas"
  },
  "Search": {
    "en": "",
    "de": "Suchen",
    "fr": "Recherche",
    "ko": "검색",
    "jp": "検索",
    "it": "Ricerca",
    "pt": "Pesquisa",
    "ru": "Поиск",
    "zh": "搜索",
    "sv": "Sök",
    "es": "Búsqueda"
  },
  "Reset": {
    "en": "",
    "de": "Zurücksetzen",
    "fr": "Reset",
    "ko": "초기화",
    "jp": "リセット",
    "it": "Resettare",
    "pt": "Reset",
    "ru": "Сбросить",
    "zh": "重置",
    "sv": "Återställ",
    "es": "Reiniciar"
  },
  "order_bucket": {
    "en": "Orders",
    "de": "Aufträge",
    "fr": "Commandes",
    "ko": "오더",
    "jp": "手配",
    "it": "Categoria di ordini",
    "pt": " Pedido",
    "ru": "Заказ",
    "zh": "订单",
    "sv": "Orders",
    "es": "Pedidos"
  },
  "all_bucket": {
    "en": "All Orders",
    "de": "Alle Aufträge",
    "fr": "Toutes les commandes",
    "ko": "전체오더",
    "jp": "すべての手配",
    "it": "Tutte le categorie",
    "pt": "Subcategoria",
    "ru": "Все",
    "zh": "所有订单",
    "sv": "All orders",
    "es": "Subcategoria"
  },
  "All": {
    "en": "",
    "de": "Gesamt",
    "fr": "Tout",
    "ko": "전체",
    "jp": "すべて",
    "it": "Tutto",
    "pt": "Tudo",
    "ru": "Все",
    "zh": "所有",
    "sv": "Alla",
    "es": "Todos"
  },
  "Ordering Period": {
    "en": "",
    "de": "Bestellperiode",
    "fr": "Période d'entrée de commandes",
    "ko": "오더 기간",
    "jp": "手配期間",
    "it": "Periodo di ordinamento",
    "pt": "Periodo de compra",
    "ru": "Период для Размещения Заказов",
    "zh": "订单期间",
    "sv": "Orderperiod",
    "es": "Periodo de pedido"
  },
  "Total": {
    "en": "",
    "de": "Gesamt",
    "fr": "Total",
    "ko": "합계",
    "jp": "合計",
    "it": "Totale",
    "pt": "Total",
    "ru": "Всего",
    "zh": "总汇",
    "sv": "Totalt",
    "es": "Total"
  },
  "Export": {
    "en": "",
    "de": "Exportieren",
    "fr": "Exporter",
    "ko": "출력",
    "jp": "エクスポート",
    "it": "Esportare",
    "pt": "Exportar",
    "ru": "Экспортировать",
    "zh": "导出",
    "sv": "Dra ut",
    "es": "Exportar"
  },
  "range1": {
    "en": "Past 7 days",
    "de": "Letzte 7 Tage",
    "fr": "7 derniers jours",
    "ko": "이전 7일",
    "jp": "過去7日",
    "it": "Ultimi 7 giorni",
    "pt": "Extensão1",
    "ru": "Промежуток1",
    "zh": "过去7天",
    "sv": "Senaste 7 dagarna",
    "es": "anoche 7 dias"
  },
  "range2": {
    "en": "8-21 days",
    "de": "8-12 Tage",
    "fr": "8 -à 21 jours",
    "ko": "이전 3주일",
    "jp": "過去8-21日",
    "it": "da 8 a 21 giorni",
    "pt": "Extensão2",
    "ru": "Промежуток2",
    "zh": "过去8-21天",
    "sv": "8-21 dagarna",
    "es": "8 - 21 dias"
  },
  "range3": {
    "en": "22-100 days",
    "de": "22-100 Tage",
    "fr": "22 à 100 jours",
    "ko": "이전 3달",
    "jp": "過去22-100日",
    "it": "da 22 a 100 giorni",
    "pt": "Extensão3",
    "ru": "Промежуток3",
    "zh": "过去22-100天",
    "sv": "22-100 dagarna",
    "es": "22 - 100 dias"
  },
  "Back": {
    "en": "Back",
    "de": "Zurück",
    "fr": "Retour",
    "ko": "뒤로",
    "jp": "戻る",
    "it": "Indietro",
    "pt": "Retornar",
    "ru": "Назад",
    "zh": "后退",
    "sv": "Tillbaka",
    "es": "Regresar"
  },
  "warn_date_range": {
    "en": "Please enter a valid date range",
    "de": "Bitte geben Sie einen gültigen Datumsbereich ein",
    "fr": "Veuillez spécifier une période",
    "ko": "올바른 기한을 입력해주세요",
    "jp": "有効な日付幅を入力ください",
    "it": "attenzione_data_intervallo",
    "pt": "Alerta intervalo de datas",
    "ru": "Не правильный промежуток времени",
    "zh": "请输入有效的日期区间",
    "sv": "Varning: Datumperiod",
    "es": "Alerta rango de fecha"
  },
  "warn_date_type": {
    "en": "Please select a date type you want to search for",
    "de": "Bitte wählen Sie den gewünschten Datumstyp aus",
    "fr": "Veuillez spécifier un type de date",
    "ko": "날자타입을 선택해주세요",
    "jp": "検索したい日付形式を選択ください",
    "it": "attenzione_data_tipo",
    "pt": "Alerta tipo de datas",
    "ru": "Не правильный вид даты",
    "zh": "请选择有效的日期类型",
    "sv": "Varning: Datumformat",
    "es": "Alerta tipo de fecha"
  },
  "warn_search_criteria": {
    "en": "Please enter proper search criteria",
    "de": "Bitte geben Sie gültige Suchkriterien ein",
    "fr": "Veuillez spécifier un critère valide",
    "ko": "올바른 검색방식을 입력해주세요",
    "jp": "検索条件を入力ください",
    "it": "attenzione_ricerca_criterio",
    "pt": "Alerta criterios de procura",
    "ru": "Не правильный пойск",
    "zh": "请输入适当的搜索条件",
    "sv": "Varning: fel i Sökkriterier",
    "es": "Alerta criterio de busqueda"
  },
  "warn_error_occured": {
    "en": "An error occured",
    "de": "Ein Fehler ist aufgetreten",
    "fr": "Une erreur s'est produite",
    "ko": "에러가 발생했습니다",
    "jp": "エラー発生",
    "it": "attenzione_errore",
    "pt": "Alerta ocorreu um erro",
    "ru": "Произошлась ошибка",
    "zh": "发现错误",
    "sv": "Varning: Fel i sökningen",
    "es": "Alerta de error"
  },
  "warn_no_search_result": {
    "en": "No result found for the given search criteria",
    "de": "Keine Ergebnisse gefunden",
    "fr": "Aucune commande trouvée",
    "ko": "검색 결과가 없습니다",
    "jp": "該当検索結果がありません",
    "it": "attenzione_nessun_risultato_ricerva",
    "pt": "Alerta sem resultado",
    "ru": "Пойск не действительный",
    "zh": "无相关搜索结果",
    "sv": "Varning: Inga sökresultat",
    "es": "Alerta busqueda sin resultado"
  },
  "warn_timeout": {
    "en": "A timeout occured. Please retry!",
    "de": "Zeitüberschreitung. Bitte versuchen Sie es noch einmal!",
    "fr": "Le système a pris trop de temps - veuillez réessayez",
    "ko": "시간이 초과되었습니다. 다시 시도해 주세요",
    "jp": "タイムアウト、条件を変えて再度検索ください",
    "it": "attenzione_fine_sessione",
    "pt": "Alerta tempo esgotado",
    "ru": "Срок действия истек",
    "zh": "超时, 请重试",
    "sv": "Varning: Tiden har gått ut",
    "es": "Alerta sesion expirada"
  },
  "warn_search_exeed_more_than": {
    "en": "Search result exceeds limit:",
    "de": "Das Ergebnis übersteigt die Begrenzung:",
    "fr": "Votre recherche a donné plus que",
    "ko": "검색결과 한도 초과",
    "jp": "検索結果はさらにあります",
    "it": "attenzione_ricerca_supera",
    "pt": "Alerta pesquisa exceder mais de",
    "ru": "Пойск слишком длинный",
    "zh": "搜索结果超过",
    "sv": "Varning: För många träffar",
    "es": "Alerta busqueda excede"
  },
  "warn_refine_search": {
    "en": "Please refine your search",
    "de": "Bitte spezifizieren Sie die Suche",
    "fr": "Veuillez affinez vos critères de recherche",
    "ko": "다른 검색 키워드를 사용하시기 바랍니다",
    "jp": "検索条件を見直してください",
    "it": "attenzione_ricerca",
    "pt": "Alerta melorar pesquisa",
    "ru": "Уточните пойск",
    "zh": "请重设您的搜索",
    "sv": "Varning förfina sökning",
    "es": "Alerta mejore busqueda"
  },
  "records": {
    "en": "",
    "de": "Einträge",
    "fr": "Ensemble de données",
    "ko": "건",
    "jp": "記録",
    "it": "archivio",
    "pt": "Arquivos",
    "ru": "Записи",
    "zh": "记录",
    "sv": "Uppgifter",
    "es": "Archivos"
  },
  "Yesterday": {
    "en": "",
    "de": "Gestern",
    "fr": "Hier",
    "ko": "어제",
    "jp": "昨日",
    "it": "ieri",
    "pt": "Ontem",
    "ru": "Вчера",
    "zh": "昨天",
    "sv": "Igår",
    "es": "Ayer"
  },
  "Last Week": {
    "en": "",
    "de": "Letzte Woche",
    "fr": "La semaine dernière",
    "ko": "지난주",
    "jp": "先週",
    "it": "La settimana scorsa",
    "pt": "Semana passada",
    "ru": "Прошлая неделя",
    "zh": "上周",
    "sv": "Förra veckan",
    "es": "Semana passada"
  },
  "Current Week": {
    "en": "",
    "de": "Aktuelle Woche",
    "fr": "Cette semaine",
    "ko": "금주",
    "jp": "今週",
    "it": "La settimana in corso",
    "pt": "Semana atual",
    "ru": "Текущая неделя",
    "zh": "本周",
    "sv": "Denna vecka",
    "es": "Semana actual"
  },
  "Last Month": {
    "en": "",
    "de": "Letzter Monat",
    "fr": "Le mois dernier",
    "ko": "지난달",
    "jp": "先月",
    "it": "Il mese scorso",
    "pt": "Mês passado",
    "ru": "Прошлый месяц",
    "zh": "上个月",
    "sv": "Förra månaden",
    "es": "El mes pasado"
  },
  "Last 3 Months": {
    "en": "",
    "de": "Letzte 3 Monate",
    "fr": "Les 3 derniers mois",
    "ko": "지난3개월",
    "jp": "過去三ヶ月",
    "it": "Ultimi 3 mesi",
    "pt": "Ultimos 3 meses",
    "ru": "Последние 3 месяца",
    "zh": "上三个月",
    "sv": "Senaste tre månaderna",
    "es": "Ultimos 3 meses"
  },
  "Current Year": {
    "en": "",
    "de": "Aktuelles Jahr",
    "fr": "Année en cours",
    "ko": "올해",
    "jp": "今年度",
    "it": "Anno currente",
    "pt": "Ano atual",
    "ru": "Текущий Год",
    "zh": "本年度",
    "sv": "Detta år",
    "es": "Año actual"
  },
  "and": {
    "en": "",
    "de": "und",
    "fr": "et",
    "ko": "그리고",
    "jp": "と",
    "it": "e",
    "pt": "e",
    "ru": "и",
    "zh": "和",
    "sv": "och",
    "es": "y"
  },
  "Order Status Dashboard Data": {
    "en": "",
    "de": "Auftragsstatus Dashboard",
    "fr": "Tableau de bord",
    "ko": "OS 대시보드 데이터",
    "jp": "オーダーステータス後注文一覧",
    "it": "Dashboard",
    "pt": "Painel",
    "ru": "рабочий стол",
    "zh": "订单状态汇总资料",
    "sv": "Order status Dashboard Data",
    "es": "Tablero de instrumentos"
  },
  "Order Status Widget Data for Order No": {
    "en": "",
    "de": "Auftragsstatus Daten für Auftrags Nr",
    "fr": "Détails de la commande",
    "ko": "오더 번호에 대한 OS 위젯 데이터",
    "jp": "手配の納期サマリ画面",
    "it": "Status ordine data per Numero Ordine",
    "pt": "Ícone do estado do pedido",
    "ru": "Краткий статус заказа :",
    "zh": "订单状态某订单号下的小窗资料 ",
    "sv": "Order status Widget Data för ordernummer",
    "es": "Icono del estado del pedido"
  },
  "My HP Orders": {
    "en": "My Orders",
    "de": "Meine HP Aufträge",
    "fr": "Mes commandes",
    "ko": "나의 오더",
    "jp": "担当者のHP手配",
    "it": "Il mio ordine HP",
    "pt": "Os meus pedidos HP",
    "ru": "Мои HP Заказы",
    "zh": "我的惠普订单",
    "sv": "Mina HP ordrar",
    "es": "Mis pedidos de HP"
  },
  "Generated on": {
    "en": "",
    "de": "Erstellt am",
    "fr": "Généré(e)(s) le",
    "ko": "생성 일자",
    "jp": "生成",
    "it": "Generato su",
    "pt": "Gerado em",
    "ru": "Создан",
    "zh": "产生在",
    "sv": "Skapad",
    "es": "Generado en"
  },
  "Account Name": {
    "en": "",
    "de": "Kundenname",
    "fr": "Nom du compte",
    "ko": "계정이름",
    "jp": "アカウント名",
    "it": "Numero conto",
    "pt": "Nome de conta",
    "ru": "Наименование учётной записи",
    "zh": "客户名称",
    "sv": "Kontonamn",
    "es": "Nombre de la cuenta"
  },
  "User First Name": {
    "en": "",
    "de": "Benutzer Vorname",
    "fr": "Prénom de l'utilisateur",
    "ko": "이름",
    "jp": "名",
    "it": "Nome utente",
    "pt": "Nome do usuario",
    "ru": "Имя Пользователя",
    "zh": "用户的名",
    "sv": "Användarens förnamn",
    "es": "Nombre de usuario"
  },
  "User Last Name": {
    "en": "",
    "de": "Benutzer Nachname",
    "fr": "Nom de l'utilisateur",
    "ko": "성",
    "jp": "苗字",
    "it": "Cognome utente",
    "pt": "Sobrenome do usuario",
    "ru": "Фамилия Пользователя",
    "zh": "用户的姓",
    "sv": "Användarens efternamn",
    "es": "Apellido de usuario"
  },
  "User ID": {
    "en": "",
    "de": "Benutzerkennung",
    "fr": "N° utilisateur",
    "ko": "User ID",
    "jp": "ユーザーID",
    "it": "Utente  ID",
    "pt": "ID de usuario",
    "ru": "ID Пользователя",
    "zh": "用户代码",
    "sv": "Användar ID",
    "es": "ID de usuario"
  },
  "Apply": {
    "en": "",
    "de": "Anwenden",
    "fr": "Appliquer",
    "ko": "적용",
    "jp": "適応",
    "it": "Applica",
    "pt": "Aplicar",
    "ru": "Подтвердить",
    "zh": "适用",
    "sv": "Använt",
    "es": "Aplicar"
  },
  "Cancel": {
    "en": "",
    "de": "Abbrechen",
    "es": "Cancelar",
    "pt": "Cancelar",
    "fr": "Annuler",
    "zh": "取消"
  },
  "From": {
    "en": "",
    "de": "Von",
    "fr": "De",
    "ko": "From",
    "jp": "From",
    "it": "Da",
    "pt": "De",
    "ru": "От",
    "zh": "从",
    "sv": "Från",
    "es": "Desde"
  },
  "To": {
    "en": "",
    "de": "Bis",
    "fr": "A",
    "ko": "To",
    "jp": "To",
    "it": "Al",
    "pt": "Até",
    "ru": "К",
    "zh": "到",
    "sv": "Till",
    "es": "Hasta"
  },
  "Custom Range": {
    "en": "",
    "de": "Benutzerdefiniert",
    "fr": "Plage de dates personalisée",
    "ko": "사용자 기간",
    "jp": "期間設定",
    "it": "Intervallo customizzato",
    "pt": "Faixa personalizada",
    "ru": "Выбрать Промежуток",
    "zh": "定制期间",
    "sv": "Anpassat intervall",
    "es": "Rango"
  },
  "Show all orders": {
    "en": "",
    "de": "Alle Aufträge anzeigen",
    "fr": "Montrer toutes les commandes",
    "ko": "전체 오더 표시",
    "jp": "すべてのオーダー表示",
    "it": "Mostra tutti gli ordini",
    "pt": "Mostrar todos os pedidos",
    "ru": "Показать Все Заказы",
    "zh": "显示所有订单",
    "sv": "Visa alla ordrar",
    "es": "Mostrar todos los pedidos"
  },
  "Sales Product Group": {
    "en": "HP Product Grouping",
    "de": "Produktgruppe",
    "fr": "Catégorie",
    "ko": "제품군",
    "jp": "HP製品グループ",
    "it": "Sales Product Group",
    "pt": "Grupo de produtos de venda",
    "ru": "Продуктовая Группа продажи",
    "zh": "销售产品组",
    "sv": "Produktgrupp",
    "es": "Grupo de producto"
  },
  "notAuthorized": {
    "en": "not authorized",
    "de": "Fehlende Zugriffsrechte",
    "fr": "non-autorisé",
    "ko": "[-]",
    "jp": "未承認",
    "it": "nonAutorizzato",
    "pt": "não autorizada",
    "ru": "Не разрешено",
    "zh": "未授权",
    "sv": "Ej tillåten",
    "es": "No autorizado"
  },
  "Invoice(s)": {
    "en": "Invoice(s)",
    "de": "Rechnungen",
    "fr": "Factures",
    "ko": "Invoice",
    "jp": "請求書",
    "it": "Fattura/e",
    "pt": "Fatura(s)",
    "ru": "счёты",
    "zh": "发票",
    "sv": "Faktura/or",
    "es": "Factura/s"
  },
  "Download all Invoices": {
    "en": "Download all Invoices",
    "de": "Alle Rechnungen downloaden",
    "fr": "Télécharger toutes les factures",
    "ko": "전체 invoice 다운로드",
    "jp": "請求詳細情報のダウンロード",
    "it": "Scarica tutte le fatture",
    "pt": "Descarregar todas as faturas",
    "ru": "Скачать все счёты",
    "zh": "下载所有发票",
    "sv": "Ladda ned alla fakturor",
    "es": "Descargar todas las facturas"
  },
  "Click here for download in zip format": {
    "en": "Click here for download in zip format",
    "de": "Hier klicken für download im ZIP format",
    "fr": "Cliquer ici pour télécharger en format zip",
    "ko": "ZIP 파일로 다운로드",
    "jp": "Zipフォーマットのダウンロードはこちらをクリック",
    "it": "Clicca qui per scaricare in formato zip",
    "pt": "Carregue aqui para descarregar em formato ZIP",
    "ru": "Скачать файлы в зип форме",
    "zh": "点击此处下载压缩格式",
    "sv": "Klicka här för att ladda ned i zip format",
    "es": "Haga click aquí para descargar en formato ZIP"
  },
  "warn_no_invoice_download": {
    "en": "Sorry you can not download invoices",
    "de": "Entschuldigung - Sie haben keine Berechtigung für einen Rechnungs-Download",
    "fr": "Attention- aucune facture téléchargée",
    "ko": "죄송합니다. Invoice를 다운로드 하실 수 없습니다",
    "jp": "申し訳ございませんが請求書のダウンロードは出来ません",
    "it": "Attenzione_nessuna_fattura_scaricata",
    "pt": "Atenção - nenhuma fatura descarregada",
    "ru": "Счёт не скачался",
    "zh": "对不起，您无法下载发票",
    "sv": "Varning: Ingen faktura nedladdad",
    "es": "Atención ninguna factura descargada"
  },
  "Invoice download started": {
    "en": "",
    "de": "Download gestartet",
    "fr": "Téléchargement initié",
    "ko": "Invoice 다운로드 시작 됨",
    "jp": "請求書のダウンロードスタート",
    "it": "Scaricamento fatture iniziato",
    "pt": "Descarga de fatura iniciada ",
    "ru": "Счёт скачается",
    "zh": "发票下载开始",
    "sv": "Fakturanedladdning påbörjad",
    "es": "Descarga de factura iniciada"
  },
  "Invoice Amount": {
    "en": "",
    "de": "Rechnungsbetrag",
    "fr": "Montant de la facture",
    "ko": "Invoice 금액",
    "jp": "請求金額",
    "it": "Importo fattura",
    "pt": "Montante fatura",
    "ru": "Стоймость счёта",
    "zh": "发票金额",
    "sv": "Fakturabelopp",
    "es": "Importe factura"
  },
  "Download Document": {
    "en": "",
    "de": "Download",
    "fr": "Télécharger le document",
    "ko": "문서 다운로드",
    "jp": "ドキュメントのダウンロード",
    "it": "Scarica documento",
    "pt": "Descarregar documento",
    "ru": "Скачать документ",
    "zh": "下载文件",
    "sv": "Ladda ned dokument",
    "es": "Descargar documento"
  },
  "found in archive system": {
    "en": "",
    "de": "im Archiv System gefunden",
    "fr": "Trouvé dans l'archive",
    "ko": "문서보관소에서 찾았습니다",
    "jp": "アーカイブに見つかりました",
    "it": "Trovato nel sistema di archiviazione",
    "pt": "Encontrado no arquivo do sistema",
    "ru": "Найдено в архиве",
    "zh": "在存档系统中找到",
    "sv": "Hittat i arkivet",
    "es": "Encontrado en el archivo del sistema"
  },
  "not found in archive system": {
    "en": "",
    "de": "nicht im Archiv System gefunden",
    "fr": "Non-trouvé dans l'archive",
    "ko": "문서보관소에서 찾을 수 없습니다",
    "jp": "アーカイブにありません",
    "it": "Non trovato nel sistema di archiviazione",
    "pt": "Não foi encontrado no arquivo do sistema",
    "ru": "Не найдено в архиве",
    "zh": "未在存档系统中找到",
    "sv": "Ej hittad i arkivet",
    "es": "No se ha encontrado en el archivo del sistema"
  },
  "not_authorized_to_view_the_requested_details": {
    "en": "There was a problem/issue with your account set-up to Order Status & Reporting.<br><br>Please contact your HP support or administrator for resolution to this issue.",
    "de": "Beim Einrichten Ihrer Benutzerrechte für Auftragsstatus und Berichterstellung im Portal ist ein Fehler aufgetreten. Bitte wenden Sie sich an den zuständigen HP Support oder Administrator.",
    "fr": "Un problème est survenu lors de la configuration de votre compte pour Edition de rapports et Statut de commande.<br><br>Adressez-vous à l'assistance HP ou à votre administrateur pour résoudre ce problème.",
    "ko": "주문 상태 및 보고에 대한 계정을 설정하는 데 문제가 있습니다.<br><br>이 문제에 대한 해결 방법을 알아보려면 HP 고객 지원 담당자나 관리자에게 문의하십시오.",
    "jp": "アカウント設定に問題が生じました。<br><br>HP サポートまたは管理者までお問い合わせください。",
    "it": "Si è verificato un problema con la configurazione dell'account per la gestione dello stato ordine e la creazione dei report.<br><br>Contattare l'amministratore o l'assistenza HP per risolvere questo problema.",
    "pt": "Há um problema com a configuração de sua conta para Status do pedido e Relatório.<br><br>Entre em contato com o suporte da HP ou com o administrador para resolução deste problema.",
    "ru": "Возникла проблема с установками Вашего аккаунта по Статусу Заказа и Отчетам. Пожалуйста, обратитесь в группу поддержки НР или к администратору, чтобы разрешить проблему.",
    "zh": "您的定单状态和生成报告中的账户设置有问题。<br><br>请联系您的HP支持或管理员解决此问题。",
    "sv": "Det uppstod ett problem med din kontokonfiguration av orderstatus och rapportering.<br><br>Kontakta HPs support eller en administratör för att få hjälp att lösa detta problem.",
    "es": "Hay un problema en su cuenta con la configuración del estado y la información de pedidos.<br><br>Consulte con el servicio de soporte de HP o con su administrador para resolver este punto."
  },
  "hp_internal_system_error": {
    "en": "hp internal system error",
    "de": "HP interner Systemfehler",
    "fr": "Non-trouvé dans l'archive",
    "ko": "문서보관소에서 찾을 수 없습니다",
    "jp": "アーカイブにありません",
    "it": "Non trovato nel sistema di archiviazione",
    "pt": "Não foi encontrado no arquivo do sistema",
    "ru": "Не найдено в архиве",
    "zh": "未在存档系统中找到",
    "sv": "Ej hittad i arkivet",
    "es": "No se ha encontrado en el archivo del sistema"
  },
  "Search your product details": {
    "en": "",
    "de": "Suche nach Produktdetails",
    "fr": "recherche sur les détails produit",
    "ko": "제품상세내역조회",
    "jp": "製品詳細を検索",
    "it": "Ricerca I dettagli del vostro prodotto",
    "pt": "Procure os detalhes do seu produto",
    "ru": "Поиск данных по продукту",
    "zh": "搜索您的产品详情",
    "sv": "Sök på produktdetaljer",
    "es": "Busque detalles de su producto"
  },
  "Serial #/Product #/Box #": {
    "en": "",
    "de": "Seriennr./Produktnr. /Box Nr.",
    "fr": "numéro de série/de produit/de colis",
    "ko": "Serial #/Product #/Box #",
    "jp": "シリアル＃／製品番号／ボックス＃",
    "it": "Seriale#,Prodotto#, box#",
    "pt": "Número de Série, Número de produto, número de caixa",
    "ru": "Серийный номер/Номер Продукта/Номер короба",
    "zh": "序列号/产品号/箱号",
    "sv": "Serienummer/Produktnummer/Boxnummer",
    "es": "Numero de serie/Numero de producto/ Numero de caja"
  },
  "warn_details_search_len": {
    "en": "Please insert additional characters for your search criteria !",
    "de": "Es ist ein Fehler aufgetreten. Falsches Suchkriterium. Bitte mindestens 6 Zeichen eingeben.",
    "fr": "Erreur, critère de recherche invalide, saisir au moins 6 caractères",
    "ko": "6개 이상의 알파벳 추가바랍니다.",
    "jp": "検索条件に問題があります",
    "it": "Si è verificato un errore. Criteri di ricerca non valido. Inserire almeno 6 caratteri",
    "pt": "Surgiu um erro. Critério de procura inválido. Digite pelo menos 6 caráteres",
    "ru": "Ошибка. Некорректные критерии поиска. Введите не менее 6 символов.",
    "zh": "搜索必须超过六个字符",
    "sv": "Ett fel uppstod. Fel i sökfältet. Sökningen måste innehålla minst 6 tecken.",
    "es": "Ha ocurrido un error. Criterio de busqueda no válido. Introduzca al menos 6 caracteres"
  },
  "Open External Widget": {
    "en": "Open External Widget",
    "de": "Externes Auftragsfenster öffnen",
    "fr": "Ouvrir l'outil de visualisation externe",
    "ko": "외부열람",
    "jp": "外部Widgetを開く",
    "it": "Aprire Widget esterno",
    "pt": "Abrir Tela Externa",
    "ru": "Открыть внешний виджет",
    "zh": "打开外部小窗",
    "sv": "Öppna en extern widget",
    "es": "Abrir pantalla externa."
  },
  "Raise a question": {
    "en": "Submit Request",
    "de": "Anfrage stellen",
    "fr": "Soumettre une question",
    "ko": "질문하기",
    "jp": "質問する",
    "it": "Rivolgere domande",
    "pt": "Fazer uma pergunta",
    "ru": "Задать вопрос",
    "zh": "提问",
    "sv": "Fråga",
    "es": "Plantear una pregunta"
  },
  "Download Product Details": {
    "en": "Download Product Details",
    "de": "Download Produktdetails",
    "fr": "télécharger les détails produit",
    "ko": "제품상세내역 다운로드",
    "jp": "製品詳細をダウンロード",
    "it": "Scarica Dettagli Prodotto",
    "pt": "Descarregar Detalhes Produto",
    "ru": "Загрузить данные по Продукту",
    "zh": "下载产品详情",
    "sv": "Ladda ner produktdetaljer",
    "es": "Descargar Detalles Producto"
  },
  "Product Details for Order Number": {
    "en": "Product Details for Order Number",
    "de": "Produktdetails ihrer Bestellnummer",
    "fr": "détails produits pour ce numéro de commande",
    "ko": "오더번호의제품정보",
    "jp": "手配の製品詳細",
    "it": "detegli del prodotto per Numero d'ordine",
    "pt": "Detalhes dos produtos para a encomenda número",
    "ru": "Данные по Продуктам для Номера Заказа",
    "zh": "对应订单号的产品详情",
    "sv": "Produktdetaljer för ordernummer",
    "es": "Detalles para los productos del HPON "
  },
  "Download Packing List": {
    "en": "Download Packing List",
    "de": "Download Lieferschein",
    "fr": "télécharger la liste de colisage",
    "ko": "패킹리스트 다운로드",
    "jp": "パッキングリストをダウンロード",
    "it": "Scarica Distinta Spedizione",
    "pt": "Descarregar Lista de Embalagem",
    "ru": "Загрузить Packing List",
    "zh": "下载装箱单",
    "sv": "Ladda ner packlista",
    "es": "Descargar Lista de Bultos"
  },
  "Order Search": {
    "en": "Order Search",
    "de": "Auftragssuche",
    "fr": "recherche par commande",
    "ko": "오더조회",
    "jp": "手配検索",
    "it": "Ricerca Ordine",
    "pt": "Pesquisa de Encomenda",
    "ru": "Поиск Заказа",
    "zh": "订单搜索",
    "sv": "Sök ordrar",
    "es": "Busqueda de Pedido"
  },
  "Product Search": {
    "en": "Product Search",
    "de": "Produktsuche",
    "fr": "recherche par produit",
    "ko": "제품조회",
    "jp": "製品検索",
    "it": "Ricerca Prodotto",
    "pt": "Pesquisa de Produto",
    "ru": "Поиск Продукта",
    "zh": "产品搜索",
    "sv": "Sök produkt",
    "es": "Busqueda de Producto"
  },
  "Download POD": {
    "en": "Download POD",
    "de": "Download Liefernachweis",
    "fr": "télécharger le bordereau de livraison",
    "ko": "다운로드POD",
    "jp": "受領書をダウンロード",
    "it": "Scarica Prova di Consegna",
    "pt": "Descarregar Comprovativo de Entrega ",
    "ru": "Загрузить POD",
    "zh": "下载签收单",
    "sv": "Ladda ner POD",
    "es": "Descargar comprobante de entrega"
  },
  "Track and Trace": {
    "en": "Track and Trace",
    "de": "Sendungsverfolgung",
    "fr": "suivi de commande",
    "ko": "화물추적",
    "jp": "配送記録",
    "it": "Traccia la spedizione",
    "pt": "Seguimento de Envio",
    "ru": "Отслеживание",
    "zh": "发货追踪",
    "sv": "Sök och spåra",
    "es": "Seguimiento de envios"
  },
  "Shipping ID": {
    "en": "Shipping ID",
    "de": "Versandnummer",
    "fr": "numéro d'expédition",
    "ko": "선적번호",
    "jp": "出荷ID",
    "it": "Spedizione ID",
    "pt": "Identificador de Envio",
    "ru": "Номер отгрузки",
    "zh": "发货号",
    "sv": "Skeppnings ID",
    "es": "Identificador de Envio"
  },
  "Delivery Comments": {
    "en": "Delivery Comments",
    "de": "Lieferkommentar",
    "fr": "Commentaire pour la livraison",
    "ko": "배송메시지",
    "jp": "出荷コメント",
    "it": " Commenti alla consegna",
    "pt": "Comentários na entrega",
    "ru": "Комментарии по доставке",
    "zh": "送货备注",
    "sv": "Leveranskommentar",
    "es": "Comentario de entrega"
  },
  "HP Order Number": {
    "en": "HP Order Number",
    "de": "HP Auftrag",
    "fr": "N° commande HP",
    "ko": "HP오더번호",
    "jp": "HP手配番号",
    "it": "Numero ordine HP",
    "pt": "Ordem HP",
    "ru": "Номер Заказа НР",
    "zh": "惠普订单号",
    "sv": "HP Order",
    "es": "Número de orden HP"
  },
  "Customer PO": {
    "en": "Customer PO",
    "de": "Kundenauftrag",
    "fr": "N° commande client",
    "ko": "고객주문번호",
    "jp": "ご注文番号",
    "it": "Ordine d'acquisto",
    "pt": "Pedido de compra",
    "ru": "Номер Заказа Партнера",
    "zh": "客户采购单号(PO)",
    "sv": "Kundens inköpsorder",
    "es": "Orden de compra del cliente"
  },
  "Shipment ID": {
    "en": "Shipment ID",
    "de": "Versandnummer",
    "fr": "numéro d'expédition",
    "ko": "선적번호",
    "jp": "出荷ID",
    "it": "Identificativo Spedizione",
    "pt": "Número de Envio",
    "ru": "Номер поставки",
    "zh": "发货号",
    "sv": "Skeppnings ID",
    "es": "Número de envío"
  },
  "HP Product No": {
    "en": "HP Product No",
    "de": "HP Produkt Nr",
    "fr": "N° produit HP",
    "ko": "HP 제품번호",
    "jp": "HP製品番号",
    "it": "No. prodotto HP",
    "pt": "Número de produto HP",
    "ru": "Номер Продукта",
    "zh": "惠普产品号",
    "sv": "Produktnummer",
    "es": "HP Número de producto"
  },
  "Serial No (Asset Tag, Ethernet Mac Addresses)": {
    "en": "Serial No (Asset Tag, Ethernet Mac Addresses)",
    "de": "Seriennr. (Asset Tag, Ethernet Mac Adressen)",
    "fr": "numéro de série (numéro d'asset, Mac address Ethernet)",
    "ko": "시리얼번호",
    "jp": "シリアルNo",
    "it": "N. di serie (Asset Tag, Ethernet Mac Addresses)",
    "pt": "Número de serie",
    "ru": "Серийный номер",
    "zh": "序列号",
    "sv": "Serienummer (asset tag, ethernet, MAC adresser)",
    "es": "Numero de Serie"
  },
  "Box No": {
    "en": "Box No",
    "de": "Boxnummer",
    "fr": "numéro de colis",
    "ko": "박스번호",
    "jp": "ボックスNo",
    "it": "No scatola",
    "pt": "Número de Caixa",
    "ru": "Номер короба",
    "zh": "箱号",
    "sv": "Box ID",
    "es": "Numero de Caja"
  },
  "Box quantity": {
    "en": "Box Quantity",
    "de": "Anzahl Boxen",
    "fr": "nombre de colis",
    "ko": "박스수량",
    "jp": "ボックス数",
    "it": "Quantita' scatola",
    "pt": "Quantidade de caixas",
    "ru": "Кол-во коробов",
    "zh": "箱数",
    "sv": "Box kvantitet",
    "es": "Cantidad de Cajas"
  },
  "Weight": {
    "en": "Weight",
    "de": "Gewicht",
    "fr": "poids",
    "ko": "무게",
    "jp": "重量",
    "it": "Peso",
    "pt": "Peso",
    "ru": "Вес",
    "zh": "重量",
    "sv": "Vikt",
    "es": "Peso"
  },
  "Dimension": {
    "en": "Dimension",
    "de": "Maße",
    "fr": "gabarit",
    "ko": "사이즈",
    "jp": "サイズ",
    "it": "Dimensione",
    "pt": "Dimensões",
    "ru": "Размер",
    "zh": "尺寸",
    "sv": "Storlek",
    "es": "Dimensiones"
  },
  "DownloadManufacturingDataToolTip": {
    "en": "Serial#, Box# and item information",
    "de": "Serien-, Boxnummer und Information zu den einzelnen Positionen",
    "fr": "Téléchargez numéros de serie, numéro de boite et les information concernant les articles",
    "ko": "공장정보다운로드",
    "jp": "製品情報ダウンロードの参照データ",
    "it": "Suggerimento su come scaricare I dati di produzione",
    "pt": "Descarregar Informação de Produção",
    "ru": "Серийный номер, номер короба и данные позиции",
    "zh": "下载工厂数据提示",
    "sv": "Ladda ner Manufacturig Data Tool Tip",
    "es": "Descargar Datos de Produccion"
  },
  "Open Qty": {
    "en": "Open Quantity",
    "de": "Offene Menge",
    "fr": "quantité restant à servir",
    "ko": "수량",
    "jp": "数量",
    "it": "Qty aperte",
    "pt": "Quantidade aberta",
    "ru": "Открытое кол-во",
    "zh": "未发货数量",
    "sv": "Öppen kvantiteet",
    "es": "Cantidad abierta"
  },
  "warn_no_pod_download": {
    "en": "No POD Found For This Order",
    "de": "Für diese Lieferung wurde kein POD gefunden",
    "fr": "Il ny a pas de POD dispoinbile pour cette livraison",
    "ko": "pod형식으로 다운로드 불가능합니다.",
    "jp": "出荷情報ダウンロードは出来ません",
    "it": "Attenzione! La prova di consegna non e' stata trovata",
    "pt": "Nenhum comprovativo de entrega para esta encomenda",
    "ru": "Для данного заказа не найден POD.",
    "zh": "无签收单可下载",
    "sv": "Ingen POD hittad för denna order",
    "es": "Ningún comprobante de entrega para este pedido"
  },
  "Price": {
    "en": "Price",
    "de": "Preis",
    "es": "Precio",
    "fr": "Prix HT",
    "it": "Prezzo",
    "jp": "価格",
    "pt": "Preço ",
    "ru": " Цена",
    "sv": "Pris",
    "zh": "价格",
    "ko": "가격",
    "nl": "Tot. prijs  "
  },
  "sentence_items_attach_block": {
    "en": "Please find the entire configuration displayed in the attachment of this email.",
    "de": "Sie finden die Aufstellung aller Positionen der Bestellung im Anhang",
    "es": "Puede encontrar la configuración completa en el documento adjunto al presente correo.",
    "fr": "Trouvez les information de la comande et les articles dans le fichier attaché",
    "it": "Vi prego di trovare nella mail allegata tutta la configurazione",
    "jp": "製品詳細についてはメールの添付ファイルを参照ください",
    "pt": "Segue em anexo a configuração completa",
    "ru": "Во вложении Вы можете найти полную конфигурацию",
    "sv": " En beskrivning av hela konfigurationen finner du bifogad i detta mail",
    "zh": "本邮件的附件中您可以找到所有的配置",
    "ko": "전체 견적내역은 본 이메일 첨부에서 확인하시길 바랍니다."
  },
  "Tracking ID": {
    "en": "",
    "ko": "추적ID",
    "jp": "トラッキングID",
    "zh": "追踪号",
    "fr": "numéro de suivi",
    "pt": "Número de seguimento",
    "it": "ID di monitoraggio",
    "es": "Numero de seguimiento",
    "sv": "Spårnings-id ",
    "de": "Tracking ID",
    "ru": "Номер отслеживания"
  },
  "Ack Qty": {
    "en": "Ack Quantity",
    "ko": "선적예상 수량",
    "jp": "出荷予定個数",
    "zh": "数量",
    "fr": "",
    "pt": "Quantidade Confirmada",
    "it": "",
    "es": "Cantidad reconocida",
    "sv": "",
    "de": "Vorgesehene Menge",
    "ru": ""
  },
  "Order Information": {
    "en": "",
    "ko": "오더정보",
    "jp": "手配情報",
    "zh": "订单信息",
    "fr": "VOTRE COMMANDE",
    "pt": "Informação do Pedido",
    "it": "INFORMAZIONI SULL'ORDINE",
    "es": "Información del pedido",
    "sv": "ORDER SUMMERING",
    "de": "Bestellinformation",
    "ru": "",
    "nl": "INFORMATIE OVER UW BESTELLING"
  },
  "Total amount": {
    "en": "",
    "ko": "총 금액",
    "jp": "総額",
    "zh": "总金额",
    "fr": "Sous total",
    "pt": "Valor Total",
    "it": "Totale IVA esclusa",
    "es": "Subtotal",
    "sv": "Summering",
    "de": "Zwischensumme    ",
    "ru": "",
    "nl": "Subtotaal  "
  },
  "Tax amount": {
    "en": "",
    "ko": "부가세 금액",
    "jp": "税金金額",
    "zh": "税额",
    "fr": "Montant TVA",
    "pt": "Valor dos Impostos",
    "it": "Totale IVA  ",
    "es": "Impuestos",
    "sv": "Moms",
    "de": "Mehrwertsteuer",
    "ru": "",
    "nl": "btw"
  },
  "Invoice Address": {
    "en": "",
    "de": "Rechnungsadresse",
    "fr": "Adresse de facturation",
    "es": "Dirección de Facturación",
    "nl": "Factuuradres",
    "sv": "Faktureringsadress",
    "it": "Indirizzo di fatturazione",
    "jp": "請求先",
    "ko": "거래명세서 발행 주소",
    "zh": "发票地址",
    "pt": "Endereço da Fatura"
  },
  "Delivery Address": {
    "en": "",
    "de": "Versandadresse",
    "fr": "Adresse de livraison",
    "es": "Dirección de Envío",
    "nl": "Bezorgadres  ",
    "sv": "Leveransadress  ",
    "it": "Indirizzo di Consegna",
    "jp": "納品先",
    "ko": "납품 주소",
    "zh": "送货地址",
    "pt": "Endereço de Entrega"
  },
  "Billing Address": {
    "en": "",
    "de": "Rechnungsadresse ",
    "fr": "Adresse de facturation",
    "es": "Dirección de Facturación",
    "nl": "Factuuradres",
    "sv": "Fakturaadress",
    "it": "Indirizzo di Fatturazione",
    "jp": "請求先",
    "ko": "계산서 발행 주소",
    "zh": "出票地址",
    "pt": "Endereço de Cobrança"
  },
  "Order value": {
    "en": "",
    "de": "Gesamtsumme",
    "fr": "Total",
    "es": "Total",
    "nl": "Totaal ",
    "sv": "Totalsumma",
    "it": "Totale IVA inclusa",
    "jp": "手配金額",
    "ko": "오더 금액",
    "zh": "订单金额",
    "pt": "Valor do Pedido"
  },
  "Event": {
    "en": "",
    "jp": "メール送信範囲",
    "fr": "évenément",
    "de": "Zustand",
    "ko": "이벤트",
    "zh": "事件",
    "es": "Evento",
    "pt": "Evento"
  },
  "Current State": {
    "en": "",
    "jp": "現在の状況　",
    "fr": "etat actuel",
    "de": "Derzeitiger Zustand",
    "ko": "현상태",
    "zh": "当前状态",
    "es": "Estado actual",
    "pt": "Estado Atual"
  },
  "Action": {
    "en": "",
    "jp": "メール送信　",
    "fr": "action",
    "de": "Aktion",
    "ko": "动作",
    "zh": "动作",
    "es": "Acción ",
    "pt": "Ação"
  },
  "OVERALL": {
    "en": "Overall",
    "jp": "全般",
    "de": "GESAMT",
    "ko": "整体状态",
    "zh": "整体状态",
    "es": "General",
    "pt": "Geral",
    "fr": "ensemble"
  },
  "Enabled": {
    "en": "",
    "jp": "有効　",
    "fr": "activé",
    "de": "Freigegeben",
    "ko": "사용가능",
    "zh": "已启用",
    "es": "Habilitado",
    "pt": "Habilitado"
  },
  "No Manufacturing data found for this order": {
    "en": "No Manufacturing data found for this order.",
    "fr": "Il n'y a pas de données de production disponible pour cette comande",
    "de": "Für diese Order wurden keine Produktionsdaten gefunden",
    "ko": "해당오더는 생산정보가 조회되지 않습ㄴ다.",
    "zh": "该订单找不到相关生产信息",
    "es": "No se han encontrado datos de fabricación para este pedido",
    "pt": "Nenhuma informação de manufatura encontrada para este pedido"
  },
  "Shipment Delay": {
    "en": "Shipment Delay",
    "es": "Envio Retrasado",
    "pt": "Embarque atrasado",
    "ko": "이벤트",
    "zh": "发货延迟",
    "de": "Lieferungsverzug",
    "fr": "Retard de livraison"
  },
  "Shipment Delay, please contact HP": {
    "en": "Shipment Delay, please contact HP",
    "es": "Envio Retrasado, Por Favor contacte a HP",
    "pt": "Embarque atrasado, por favor entre em contato com a HP",
    "zh": "如遇发货延迟，请联系HP",
    "de": "Lieferungsverzug, bitte HP kontaktieren",
    "fr": "Retard de livraison, veuillez contacter HP",
    "ko": "선적 지연, HP에 문의 하세요"
  },
  "No POD was received please check with carrier": {
    "en": "No POD was received, please check with the carrier",
    "es": "Comprobante de entrega no recibido, favor de revisar con la paqueteria",
    "pt": "Comprovante de entrega não recebido. Por favor, checar com a transportadora",
    "ko": "POD 정보확인 불가하여 물류팀과 확인 요청합니다.",
    "zh": "没有订单签收信息 请与物流承运商联系",
    "de": "Kein ABL erhalten, bitte mit der Spedition prüfen",
    "fr": "Bon de livraison pas reçu; veuillez vérifier avec le transporteur"
  },
  "Partial Delivery": {
    "en": "Partial Delivery",
    "es": "Entrega Parcial",
    "pt": "Entrega parcial",
    "de": "Teillieferung",
    "fr": "livraison partielle",
    "zh": "部分发货",
    "ko": "분할 배송"
  },
  "Shipment Damaged": {
    "en": "Shipment Damaged",
    "es": "Envío dañado",
    "pt": "Carga Danificada",
    "fr": "colis endommage",
    "zh": "货物损坏",
    "ko": "선적 파손",
    "de": "Beschädigte Lieferung"
  },
  "To be advised": {
    "en": "",
    "zh": "另待通知",
    "es": "A ser informado",
    "pt": "Em análise",
    "fr": "date a venir",
    "ko": "추후 공고"
  },
  "Attempted Delivery": {
    "en": "",
    "es": "Intento de entrega",
    "pt": "Tentativa de Entrega",
    "fr": "tentative de livraison",
    "zh": "尝试投递失败",
    "ko": "미배송 "
  },
  "Carrier Estimated Delivery": {
    "en": "",
    "es": "Entrega estimada de la paquetería",
    "pt": "Entrega estimada da Transportadora",
    "fr": "livraison prevue",
    "zh": "承运商预计送货",
    "ko": "케리어 예상 배송날짜"
  },
  "Delivery Appointment Rescheduled": {
    "en": "",
    "es": "Cita de entrega reprogramada",
    "pt": "Reagendado",
    "fr": "date de livraison cahange",
    "zh": "送货时间更改",
    "ko": "예약 배송 조정 "
  },
  "Delv Appt Scheduled": {
    "en": "Delivery Appointment Scheduled",
    "es": "Cita de entrega programada",
    "pt": "Entrega agendada",
    "fr": "date de livraison  planifiee",
    "ko": "예약 배송 조정",
    "zh": "预定送货时间"
  },
  "Held at Customs": {
    "en": "",
    "es": "Retenido en aduana",
    "pt": "Retido na alfândega",
    "fr": "bloque a la douane",
    "zh": "等待海关检查",
    "ko": "고객 홀드"
  },
  "Missed Delivery": {
    "en": "",
    "es": "Entrega perdida",
    "pt": "Entrega perdida",
    "ko": "배송 누락",
    "zh": "发货遗漏"
  },
  "Reconsigned": {
    "en": "",
    "es": "Redireccionado",
    "pt": "Redirecionado",
    "ko": "재 발송",
    "zh": "重新调度"
  },
  "Shipment Cancelled: Damaged from HP Shipping Point": {
    "en": "",
    "es": "Envío cancelado: Dañado desde el punto de envío de HP",
    "pt": "Embarque Cancelado: Danificado no ponto de envio HP",
    "ko": "선적 취소:HP 선적지에서 파손",
    "zh": "取消送货：货物损坏",
    "de": "Stornierte Lieferung: Ware vom HP Shipping Point ist beschädigt"
  },
  "Shipment Cancelled: Held for Payment": {
    "en": "",
    "es": "Envío cancelado: Retenido para pago",
    "pt": "Embarque Cancelado: Retido para pagamento",
    "ko": "선적 취소:지불 홀드중",
    "zh": "取消送货：等待付款"
  },
  "Shipment Cancelled: Insufficient Delivery Time": {
    "en": "",
    "es": "Envío cancelado: Tiempo de entrega insuficiente",
    "pt": "Embarque Cancelado: Tempo insuficiente para entrega",
    "ko": "선적 취소:불 총부한 배송 시간",
    "zh": "取消送货：派送时间不足"
  },
  "Shipment Cancelled: Refused by Customer": {
    "en": "",
    "es": "Envío cancelado: Rechazado por el cliente",
    "pt": "Embarque Cancelado: Rejeitado pelo cliente",
    "zh": "取消送货：客户拒收",
    "ko": "선적 취소:고객 거절",
    "de": "Stornierte Lieferung: Ware wurde vom Kunden abgelehnt"
  },
  "Shipment Cancelled: Returned to Shipper": {
    "en": "",
    "es": "Envío cancelado: Devuelto a la paquetería",
    "pt": "Embarque Cancelado:  Retornado à expedição",
    "zh": "取消送货：被退回",
    "ko": "선적 취소:출하자로 복귀",
    "de": "Stornierte Lieferung: Ware wurde dem Spediteur zurück gegeben"
  },
  "Shipment Delayed: Awaiting Export": {
    "en": "",
    "es": "Envío retrasado: a la espera de la exportación",
    "pt": "Embarque atrasado: Aguardando exportação",
    "zh": "延迟送货：等待出口",
    "ko": "선적 지연:수출 대기중 ",
    "de": "Lieferungsverzug: Ware ist im Export"
  },
  "Shipment Delayed: Border Clearance": {
    "en": "",
    "es": "Envío retrasado: aclaración en la frontera",
    "pt": "Embarque atrasado: Liberação na fronteira",
    "zh": "延迟送货：正在清关",
    "ko": "선적 지연:국경 통관",
    "de": "Lieferungsverzug: Zollabwicklung"
  },
  "Shipment Delayed: Consignee Closed": {
    "en": "",
    "es": "Envío retrasado: destinatario cerrado",
    "pt": "Embarque atrasado: Destinatário fechado",
    "zh": "延迟送货：收货场地关闭",
    "ko": "선적 지연:인수자 마감"
  },
  "Shipment Delayed: Consignee Related": {
    "en": "",
    "es": "Envío retrasado: relacionado con el destinatario",
    "pt": "Embarque atrasado: Relacionado com destinatário",
    "ko": "선적 지연:인수자 관련",
    "zh": "延迟送货：收货人相关"
  },
  "Shipment Delayed: Cust. Req'd. Future Delivery": {
    "en": "Shipment Delayed: Customer Requested Future Delivery",
    "es": "Envío retrasado: Entrega solicitada por el cliente en lo posterior",
    "pt": "Embarque atrasado: Entrega solicitada pelo cliente para data futura",
    "zh": "延迟送货：客户指定时间",
    "ko": "선적 지연:고객 미래배송 요청",
    "de": "Lieferungsverzug: Kunde hat spätere Anlieferung beantragt"
  },
  "Shipment Delayed: Damaged, Rewrapped in Hub": {
    "en": "",
    "es": "Envío retrasado: dañado, reempaquetado en el Hub",
    "pt": "Embarque atrasado: Danificado. Reembalado no Hub.",
    "zh": "延迟送货：货物损坏，重新包装",
    "ko": "선적 지연:파손, Hub에서 재포장"
  },
  "Shipment Delayed: Driver Related": {
    "en": "",
    "es": "Envío retrasado: relacionado con el conductor",
    "pt": "Embarque atrasado: Relacionado ao motorista",
    "ko": "선적 지연:기사 관련",
    "zh": "延迟送货：司机相关"
  },
  "Shipment Delayed: Exceeds Carrier Service Limitations": {
    "en": "",
    "es": "Envío retrasado: retenido en la aduana",
    "pt": "Embarque atrasado: Excede os limites da transportadora",
    "ko": "선적 지연:운반자 서비스 제한을 초과",
    "zh": "延迟送货：超出送货条件"
  },
  "Shipment Delayed: Held at Customs": {
    "en": "",
    "es": "Envío retrasado: retenido por el destinatario",
    "pt": "Embarque atrasado: Retido na alfândega",
    "ko": "선적 지연:통관 홀드",
    "zh": "延迟送货：等待海关审查"
  },
  "Shipment Delayed: Held for Consignee": {
    "en": "",
    "es": "Envío retrasado: retenido por cita pendiente",
    "pt": "Embarque atrasado: Retido pelo destinatário",
    "ko": "선적 지연:인수자 홀드",
    "zh": "延迟送货：等待重新配送"
  },
  "Shipment Delayed: Held Pending Appt.": {
    "en": "",
    "es": "Envío retrasado: retenido por el trasportista",
    "pt": "Embarque atrasado: Aguardando agendamento",
    "ko": " 선적지연 : 사전약속에 의한 보류",
    "zh": "延迟送货：等待预约派送"
  },
  "Shipment Delayed: Held per Shipper": {
    "en": "",
    "es": "Envío retrasado: cerrado por día festivo",
    "pt": "Embarque atrasado: Retido na transportadora",
    "zh": "延迟送货：等待承运商",
    "ko": " 선적지연 : Shipper 에 의한 보류"
  },
  "Shipment Delayed: Holiday - Closed": {
    "en": "",
    "es": "Envío retrasado: cerrado por día festivo",
    "pt": "Embarque atrasado: Fechado - Feriado",
    "zh": "延迟送货：公共假期",
    "ko": "선적 지연:휴업 "
  },
  "Shipment Delayed: Improper Int'l Paperwork": {
    "en": "Shipment Delayed: Improper International Paperwork",
    "es": "Envío retrasado: documentos Internacionales incorrectos",
    "pt": "Embarque atrasado: Documentação internacional incorreta",
    "ko": " 선적지연 : 서류 작업 오류",
    "zh": "延迟送货：文书不正确",
    "fr": ""
  },
  "Shipment Delayed: Improper Unloading Facility/Equip.": {
    "en": "Shipment Delayed: Improper Unloading Facility/Equipment",
    "es": "Envío retrasado: descarga indebida Instalaciones/ Equipo",
    "pt": "Embarque atrasado: Área/Equipamentos para desembarque impróprios",
    "ko": " 선적지연 : 부적절한 하역 시설/장비",
    "zh": "延迟送货：不当的卸货工具"
  },
  "Shipment Delayed: Incorrect Address": {
    "en": "",
    "es": "Envío retrasado: dirección incorrecta.",
    "pt": "Embarque atrasado: Endereço incorreto",
    "zh": "送货延迟：地址有误",
    "ko": "선적 지연:잘 못 된 주소"
  },
  "Shipment Delayed: Int'l Non-Carrier Delay": {
    "en": "Shipment Delayed: International Non-Carrier Delay",
    "es": "Envío retrasado: Retraso internacional fuera de la paquetería",
    "pt": "Embarque atrasado: Atraso internacional, não relativo à transportadora",
    "ko": "선적 지연:국제 비-운반자 지연",
    "zh": "送货延迟：承运商延迟"
  },
  "Shipment Delayed: Mechanical Breakdown": {
    "en": "",
    "es": "Envío retrasado: descompostura mecánica",
    "pt": "Embarque atrasado: Quebra mecânica",
    "zh": "送货延迟：机械故障",
    "ko": "선적 지연:기계 고장"
  },
  "Shipment Delayed: Missed Delivery": {
    "en": "",
    "es": "Envío retrasado: Entrega perdida",
    "pt": "Embarque atrasado: Falha na entrega",
    "ko": "선적 지연:배송 누락",
    "zh": "送货延迟：派送遗漏"
  },
  "Shipment Delayed: Missed PickUp": {
    "en": "",
    "es": "Envío retrasado: recolección perdida",
    "pt": "Embarque atrasado: Coleta perdida",
    "ko": "선적 지연:픽업 누락",
    "zh": "送货延迟：取件遗漏"
  },
  "Shipment Delayed: Missing Documents": {
    "en": "",
    "es": "Envío retrasado: falta de documentos",
    "pt": "Embarque atrasado: Falta de documentação",
    "zh": "延迟送货：缺少文件",
    "ko": "선적 지연:문서 누락"
  },
  "Shipment Delayed: Other Carrier-Related": {
    "en": "",
    "es": "Envío retrasado: Otros relacionados con la paquetería",
    "pt": "Embarque atrasado: Outros motivos relacionados à transportadora",
    "ko": "선적 지연:운반자 관련",
    "zh": "延迟送货：其它承运商相关问题"
  },
  "Shipment Delayed: Past Cutoff Time": {
    "en": "",
    "es": "Envío retrasado: Se pasó el tiempo de corte",
    "pt": "Embarque atrasado: Após data de corte",
    "ko": "선적 지연:마감시간 초과",
    "zh": "延迟送货：超出限定时间"
  },
  "Shipment Delayed: Reconsigned": {
    "en": "",
    "es": "Envío retrasado: Redireccionado",
    "pt": "Embarque atrasado: Redirecionado",
    "ko": "선적 지연:재 발송",
    "zh": "延迟送货：重新配送"
  },
  "Shipment Delayed: Restricted Articles Unacceptable": {
    "en": "",
    "es": "Envío retrasado: Artítulos restringidos no aceptados",
    "pt": "Embarque atrasado: Itens restritos não aceitos",
    "zh": "延迟送货：违禁品"
  },
  "Shipment Delayed: Shipment Mis-Sort": {
    "en": "",
    "es": "Envío retrasado: envío incorrecto",
    "pt": "Embarque atrasado: Carga incorreta",
    "ko": "선적 지연:선적 분류이슈",
    "de": "Lieferungsverzug durch verwechselte Lieferung",
    "zh": "延迟送货：货物分拣错误"
  },
  "Shipment Delayed: Shipper Related": {
    "en": "",
    "es": "Envío retrasado: relacionado con el remitente",
    "pt": "Embarque atrasado: Relacionado com o remetente",
    "de": "Lieferungsverzug durch die Spedition",
    "fr": "Retard de livraison côté expéditeur",
    "ko": "선적 지연:출하자 관련",
    "zh": "延迟送货：承运商相关"
  },
  "Shipment Delayed: Unable to Locate Customer": {
    "en": "",
    "es": "Envío retrasado: no se puede localizar al cliente",
    "pt": "Embarque atrasado: Cliente não localizado",
    "zh": "延迟发货：无法联系客户",
    "ko": "선적 지연:고객 위치 불가능",
    "de": "Lieferungsverzug: der Kunde konnte nicht gefunden werden"
  },
  "Shipment Delayed: Waiting for Customer Pick-Up": {
    "en": "",
    "es": "Envío retrasado: esperando a que el cliente pase por él",
    "pt": "Embarque atrasado: Aguardando coleta do cliente",
    "zh": "延迟发货：等待客户提货",
    "ko": "선적 지연:고객 픽업 대기중",
    "de": "Lieferungsverzug: Kunde hat die Ware nicht abgeholt"
  },
  "Shipment Delayed: Waiting Inspection": {
    "en": "",
    "es": "Envío retrasado: Inspección en espera",
    "pt": "Embarque atrasado: Aguardando inspeção",
    "zh": "延迟发货：等待检查",
    "ko": "선적 지연:검사 대기중"
  },
  "Shipment Delayed: Waiting Shipping Instructions": {
    "en": "",
    "es": "Envío retrasado: esperando instrucciones de envío",
    "pt": "Embarque atrasado: Aguardando instruções de envio",
    "zh": "延迟发货：等待发货指令",
    "ko": "선적 지연:선박 대기중"
  },
  "Shipment Delayed: Weather or Natural Disaster": {
    "en": "",
    "es": "Envío retrasado: clima o desastre natural",
    "pt": "Embarque atrasado: Clima ou desastres naturais",
    "zh": "送货延迟：恶劣天气",
    "ko": "선적 지연:기상 / 자연재해",
    "de": "Lieferungsverzug durch Wetter oder Naturkatastrophen"
  },
  "Pending Credit Check": {
    "en": "",
    "de": "Bonitätsprüfung in Bearbeitung",
    "fr": "Dans l’attente d’une vérification du Service Financier",
    "es": "Cheque de crédito pendiente",
    "pt": "Checagem de Crédito Pendente",
    "zh": "等待信用额度审核",
    "ko": "여신 채크 대기중 "
  },
  "Material Constraint": {
    "en": "",
    "de": "Materialengpass",
    "fr": "Contrainte de matériel",
    "es": "Restricción de material ",
    "pt": "Restrição de Material",
    "zh": "物料紧缺",
    "ko": "자재 제한 "
  },
  "Purchaser email": {
    "en": "",
    "es": "Correo electrónico del comprador",
    "fr": "Acheteur",
    "pt": "Email comprador",
    "de": "E-Mail-Adresse Besteller",
    "zh": "购买人邮箱",
    "ko": "구입자 이메일"
  },
  "Ship to contact email": {
    "en": "",
    "es": "Email contacto entrega",
    "fr": "Contact pour la livraison",
    "pt": "Email contato de entrega",
    "de": "E-Mail-Adresse Versandanweisungen",
    "zh": "收货人联系邮箱",
    "ko": "인수자 이메일"
  },
  "HP Order Status": {
    "en": "",
    "es": "HP Situación Pedidos",
    "fr": "Statut commande HP",
    "pt": "Estado da encomenda HP",
    "de": "HP Auftragsstatus",
    "zh": "惠普订单状态",
    "ko": "오더 상태"
  },
  "Shipment number": {
    "en": "",
    "es": "Número de envío",
    "fr": "Numéro colis",
    "pt": "Número de envio",
    "de": "Sendungsnummer",
    "zh": "运单号",
    "ko": "선적번호"
  },
  "Track & Trace": {
    "en": "",
    "es": "Seguimiento",
    "de": "Sendungsverfolgung",
    "pt": " Acompanhamento de envio",
    "zh": "信息跟踪",
    "ko": " 운송 추적"
  },
  "Planned Customer Ship Date": {
    "en": "",
    "es": "Fecha prevista de envio a cliente",
    "fr": "Date estimative de sortie de production",
    "pt": "Data prevista para envio ao cliente",
    "de": "Geplanter Versandtermin",
    "zh": "预计送货时间",
    "ko": "예상선적일자"
  },
  "PublicViewOrderNotFound": {
    "en": "The order could not be found with the data you entered",
    "es": "La orden no se ha encontrado con los datos proporcionados",
    "de": "Der Auftrag konnte mit den von Ihnen eingegebenen Daten nicht gefunden werden",
    "fr": "La commande n'a pas pu être trouvée avec les données que vous nous avez fournies",
    "it": "L’ordine non può essere trovato con i dati inseriti",
    "pt": "A encomenda não pôde ser encontrada com os dados inseridas",
    "jp": " 入力された内容ではオーダーがありません。",
    "zh": "无法找到该订单",
    "ko": "오더가 조회되지 않습니다"
  },
  "CaptchaValidationNeeded": {
    "en": "Please enter the Captcha",
    "es": "Necesita validar el código de imagen",
    "de": "Bitte geben Sie den Zufallscode ein",
    "fr": "Veuillez introduire votre code de validation",
    "it": "Si prega di inserire il codice di validazione",
    "pt": "Por favor indique o Captcha",
    "jp": "画像に表示されている文字を入力してください。",
    "zh": "请输入验证码",
    "ko": "확인 필요 합니다"
  },
  "Please enter all search criteria": {
    "en": "Please enter all search criteria",
    "es": "Por favor, introduzca todos los criterios de búsqueda",
    "de": "Bitte geben Sie alle Suchkriterien ein",
    "fr": "Entrez tous les éléments de recherche",
    "it": "Per favore inserite tutti criteri di ricerca",
    "pt": "Digite todos os criterios de pesquisa",
    "zh": "请输入全部搜索条件",
    "ko": "검색조건을 전부 기입하세요"
  },
  "CaptchaDoesNotMatch": {
    "en": "Your entry does not match the Captcha",
    "es": "El código de imagen no coincide",
    "de": "Ihre Eingabe stimmt nicht mit dem Zufallscode überein",
    "fr": "Veuillez introduire votre code de validation",
    "it": "I dati inseriti non corrispondono con il codice di validazione",
    "pt": "Sua/Vossa entrada não coincide com o Captcha",
    "jp": " 入力された文字が間違っています。",
    "zh": "验证码输入错误",
    "ko": "매칭되지 않습니다"
  },
  "date will follow": {
    "en": "",
    "es": "La fecha seguirá",
    "pt": "Data a ser informada",
    "de": "Datum folgt",
    "ko": "추후공지됨"
  },
  "Manual Hold ATP,RTE,EPO(noTBA)": {
    "en": "",
    "es": "Retención de pedidos",
    "pt": "Bloqueio manual"
  },
  "Export Licence Reject": {
    "en": "",
    "es": "Rechazo de licencia de exportación",
    "pt": "Licença de exportação rejeitada",
    "zh": "出口信用证拒发",
    "ko": "수출라이센스 리젝"
  },
  "Failed site assignment": {
    "en": "",
    "es": "Asignación de sitio errónea",
    "pt": "Falha em assignação",
    "zh": "站点分配失败"
  },
  "Credit under<br>validation": {
    "en": "",
    "es": "Pendiente de verificar credito",
    "pt": "Sob análise de crédito",
    "de": "Bonitätsprüfung",
    "fr": "Crédit en cours de validation",
    "zh": "信用额度审核中",
    "ko": "여신 확인 중",
    "it": "Convalida credito in corso"
  },
  "Search Result": {
    "en": "",
    "zh": "搜索结果",
    "pt": "Resultado da busca",
    "es": "Resultado de la búsqueda",
    "de": "Suchergebnis",
    "fr": "Résultat recherche",
    "ko": "검색결과",
    "it": "Risultato ricerca"
  },
  "Partner contact country MDM": {
    "en": "",
    "zh": "合作夥伴聯繫國家MDM",
    "pt": "Contato do parceiro no país",
    "es": "Contacto del socio en el país"
  },
  "Planner Comment: Partner contact country MDM": {
    "en": "",
    "zh": " 计划者评论：合作伙伴联系国家MDM",
    "pt": "Comentário de planejamento: Contato do parceiro no país",
    "es": "Comentario del planificador: Contacto del socio en el país"
  },
  "Order pending validation": {
    "en": "",
    "es": " Orden pendiente de validación",
    "pt": "Pedido aguardando validação",
    "zh": "订单正在审核",
    "ko": "오더 홀딩 확인"
  },
  "Customer comment validation": {
    "en": "",
    "es": "Validación de comentarios de clientes",
    "pt": "Validação de comentário do cliente",
    "zh": "客户注释审核",
    "ko": "고객 코멘트 확인"
  },
  "Help": {
    "en": "",
    "de": "Hilfe",
    "fr": "Assistance",
    "zh": "帮助",
    "es": "Ayuda",
    "pt": "Ajuda",
    "ko": "도움",
    "it": "Aiuto"
  },
  "Manufacturing Data Search": {
    "en": "",
    "de": "Suche: Fertigungsinformationen",
    "fr": "Recherche Données Fabrication",
    "es": "Búsqueda de datos de manufactura",
    "pt": "Pesquisa por data de manufatura",
    "zh": "产品信息搜索",
    "ko": "제조일자 조회",
    "it": "Ricerca dati di fabbricazione"
  },
  "Quick Search": {
    "en": "",
    "de": "Schnellsuche",
    "fr": "Recherche Rapide",
    "zh": "快速查询",
    "es": "Búsqueda rápida",
    "pt": "Pesquisa rápida",
    "it": "Ricerca veloce"
  },
  "Search Value": {
    "en": "",
    "de": "Suchkriterium",
    "fr": "Sélection recherche",
    "zh": "查询值",
    "es": "Buscar Valor",
    "pt": "Campo de Pesquisa",
    "it": "Criterio di ricerca"
  },
  "Dashboard": {
    "en": "",
    "de": "Dashboard",
    "fr": "Dashboard",
    "zh": "总览",
    "es": "Tablero",
    "pt": "Painel",
    "it": "Dashboard"
  },
  "LastOrdersViewed": {
    "en": "",
    "de": "zuletzt angesehene Bestellungen",
    "fr": "Dernières commandes consultées",
    "zh": "最近查看过的订单",
    "es": "ÚltimasórdenesVistas",
    "pt": "Ultimas ordens vistas",
    "it": "Ultimi ordini visionati"
  },
  "LastOrdersPlaced": {
    "en": "",
    "de": "zuletzt bestellt",
    "fr": "Dernières commandes placées",
    "zh": "最近已下订单",
    "es": "ÚltimasÓrdenesIngresadas",
    "pt": "Ultimas ordens colocadas",
    "it": "Ultimi ordini passati"
  },
  "LastOrdersShipped": {
    "en": "",
    "de": "zuletzt verschickt",
    "fr": "Derniers commandes expédiées",
    "zh": "最近出厂订单",
    "es": "ÚltimasÓrdenesEmbarcadas",
    "pt": "Ultimas ordens embarcadas",
    "it": "Ultimi ordini spediti"
  },
  "Placed last 100 days": {
    "en": "",
    "de": "bestellt in den letzten 100 Tagen",
    "fr": "Placées 100 derniers jours",
    "es": "Últimas 100 órdenes ingresadas",
    "pt": "Colocadas nos ultimos 100 dias",
    "ko": "지난 100일간 발주됨",
    "it": "Ordini passati negli ulitmi 100 giorni",
    "zh": "最近100天内的订单"
  },
  "User Guide": {
    "en": "",
    "de": "Benutzerhandbuch",
    "fr": "Guide de l'utilisateur",
    "zh": "用户指导",
    "es": "Guía de usuario",
    "pt": "Guia do usuário",
    "ko": "유저 가이드",
    "it": "Guida all'utilizzazione"
  },
  "User defined Settings": {
    "en": "",
    "de": "Benutzereinstellungen",
    "fr": "Configuration utilisateur",
    "zh": "用户设置",
    "es": "Configuración definida por el usuario",
    "pt": "Configurações do usuário",
    "ko": "유저 가이드",
    "it": "Impostazioni utente"
  },
  "Credit<br>approved": {
    "en": "",
    "de": "Bonität bestätigt",
    "fr": "Crédit approuvé",
    "es": "Crédito aprobado",
    "pt": "Crédito aprovado",
    "zh": "信用审核通过",
    "ko": "여신 승인됨",
    "it": "Credito approvato"
  },
  "Credit<br>rejected": {
    "en": "",
    "de": "Bonität abgelehnt",
    "fr": "Crédit rejeté",
    "es": "Crédito Rechazado",
    "pt": "Crédito Rejeitado",
    "zh": "信用审核未通过",
    "ko": "여신 리젝됨",
    "it": "Credito rifiutato"
  },
  "Trade Order": {
    "en": "",
    "de": "Kundenbestellung",
    "fr": "Commande commerciale",
    "es": "Orden Comercial",
    "pt": "Ordem de Venda",
    "zh": "订单",
    "ko": "구매 오더",
    "it": "Ordine commerciale"
  },
  "Agent Id": {
    "en": "",
    "de": "Agent ID",
    "fr": "ID d'Agent",
    "es": "Número de Agente",
    "pt": "Agente ID",
    "zh": "Agent ID",
    "ko": "에이젼트 ID",
    "it": "N. agente"
  },
  "Deal Id": {
    "en": "",
    "de": "Deal ID",
    "fr": "ID de transaction",
    "es": "Número de Convenio",
    "pt": "ID do Deal",
    "zh": "Eclipse Deal ID",
    "ko": "딜넘버",
    "it": "N. deal"
  },
  "Payment terms": {
    "en": "",
    "de": "Zahlungsbedingungen",
    "fr": "Conditions de paiement",
    "zh": "付款条件",
    "es": "Términos de pago",
    "pt": "Termos de pagamento",
    "ko": "상환기간",
    "it": "Condizioni di pagamento"
  },
  "Export data of this order into Excel": {
    "en": "",
    "de": "Export in Excel",
    "fr": "Exporter les données de la commande dans Excel",
    "zh": "将数据导出到Excel中",
    "es": "Exportar los datos a Excel",
    "pt": "Exportar dados desta ordem para o Excel ",
    "ko": "엑셀추출",
    "it": "Esporta I dati dell'ordine su Excel"
  },
  "Search orders based on manufacturing data": {
    "en": "",
    "de": "Bestellungssuche basierend auf Produktionsinformationen",
    "fr": "Recherche par données de fabrication",
    "es": "Búsqueda de órdenes basado en datos de manufactura",
    "pt": "Pesquisar ordens baseado na data de manufatura",
    "zh": "根据产品信息搜索订单",
    "ko": "제조일자 기준으로 오더 조회",
    "it": "Ricerca ordini partendo dai dati di fabbricazione"
  },
  "Ship to Attention": {
    "en": "",
    "de": "Kontakt für Warenannahme",
    "fr": "Envoyé à l'attention",
    "zh": "送货联系人",
    "es": "Datos de envío",
    "pt": "Contato de entrega",
    "ko": "배송주의사항",
    "it": "Spedito all'attenzione di"
  },
  "Asset Tag": {
    "en": "",
    "de": "Bestandsnummer",
    "fr": "Étiquette d'actif",
    "es": "Etiqueta del producto",
    "pt": "etiqueta de ativos",
    "zh": "资产编号",
    "ko": "자산태크",
    "it": "Asset Tag"
  },
  "Primary Mac Address": {
    "en": "",
    "de": "Primäre MAC Adresse",
    "fr": "Adresse Mac primaire",
    "es": "Mac Address Primario",
    "pt": "Endereço Mac primário",
    "zh": "主MAC 地址",
    "ko": "MAC 주소",
    "it": "Mac Address principale"
  },
  "UUID": {
    "en": "",
    "de": "UUID (universally unique identifier)",
    "fr": "Numéro UUID",
    "es": "UUID",
    "pt": "Numerãção UUID",
    "zh": "UUID",
    "ko": "UUID",
    "it": "UUID"
  },
  "IMEI": {
    "en": "",
    "de": "IMEI (international mobile equipment identity)",
    "fr": "Numéro IMEI",
    "zh": "串号",
    "es": "IMEI",
    "pt": "Númeração IMEI",
    "ko": "IMEI",
    "it": "IMEI"
  },
  "BIOS Version": {
    "en": "",
    "de": "BIOS Version",
    "fr": "Version du BIOS",
    "zh": "显卡版本",
    "es": "Versión BIOS",
    "pt": "Versão BIOS",
    "ko": "BIOS 버전",
    "it": "Versione BIOS"
  },
  "Serial number of SSD disk": {
    "en": "",
    "de": "Seriennummer SSD disk",
    "fr": "Numéro de série du disque SSD",
    "es": "Número de serie del disco SSD",
    "pt": "Númedo de série disco SSD",
    "zh": "硬盘序列号",
    "ko": "SSD 디스크 시리얼 넘버",
    "it": "N. di serie del disco SSD"
  },
  "Manufacturing Date": {
    "en": "",
    "de": "Produktionsdatum",
    "fr": "Date de fabrication",
    "es": "Fecha de manufactura",
    "pt": "Data de Manufatura",
    "zh": "生产日期",
    "ko": "제조일자",
    "it": "Data di fabbricazione"
  },
  "System Info": {
    "en": "",
    "de": "Systeminformation",
    "fr": "Infos de Système",
    "zh": "系统信息",
    "es": "Información de sistema",
    "pt": "Informação do sistema",
    "ko": "시스템 정보",
    "it": "Informazioni di sistema"
  },
  "2ndMACAddr": {
    "en": "",
    "de": "2nd MAC Address",
    "fr": "2ème Adresse Mac",
    "es": "2ndMACAddr",
    "pt": "2ndMACAddr",
    "zh": "2nd MAC地址",
    "ko": "2nd MAC 주소",
    "it": "Secondo Mac Address"
  },
  "3rdMACAddr": {
    "en": "",
    "de": "3rd MAC Address",
    "fr": "3ème Adresse Mac",
    "es": "3rdMACAddr",
    "pt": "3rdMACAddr",
    "zh": "3rd MAC 地址",
    "ko": "3rd MAC 주소",
    "it": "Terzo Mac Address"
  },
  "4thMACAddr": {
    "en": "",
    "de": "4th MAC Address",
    "fr": "4ème Adresse Mac",
    "es": "4thMACAddr",
    "pt": "4thMACAddr",
    "zh": "4th MAC 地址",
    "ko": "4th MAC 주소",
    "it": "Quarto Mac Address"
  },
  "Pallet-TrackID": {
    "en": "",
    "de": "Palettennummer",
    "fr": "ID de Trace Palette",
    "es": "Código de rastreo de Pallet",
    "pt": "ID do pallet",
    "zh": "托盘ID",
    "ko": "팔렛 추적 ID",
    "it": "Track ID - Pallet"
  },
  "MasterCarton-TrackID": {
    "en": "",
    "de": "Master Carton Nummer",
    "fr": "ID de Trace Carton de maître",
    "es": "Código de rastreo de MasterCarton",
    "pt": "ID da caixa principal",
    "zh": "纸箱ID",
    "ko": "카턴 추적 ID",
    "it": "Track ID - Master Carton"
  },
  "Single-Unit-TrackID": {
    "en": "",
    "de": "Stücknummer",
    "fr": "ID de Trace d'Unité Seul",
    "es": "Código de unidad de rastreo",
    "pt": "ID da unidade",
    "ko": "제품 추적 ID",
    "zh": "单机编号",
    "it": "Track ID - unita' singola"
  },
  "Invoice UDFs:": {
    "en": "",
    "de": "zusätzliche Rechnungsinformation",
    "es": "Factura de UDFs",
    "pt": "UDFs da Nota Fiscal",
    "zh": "发票UDF",
    "ko": "인보이스 UDF",
    "it": "Fattura UDF"
  },
  "Freight Charge:": {
    "en": "",
    "de": "Transportkosten",
    "fr": "Frais de PORT",
    "zh": "运费",
    "es": "Cargos de envío",
    "pt": "Taxa de frete",
    "ko": "운송비",
    "it": "Spese di trasporto"
  },
  "Local installation contact phone #": {
    "en": "",
    "de": "Installationskontakt vor Ort: Telefonnummer",
    "fr": "Téléphone : Contact installation locale",
    "zh": "当地安装联系人电话",
    "es": "Teléfono de contacto para instalación local",
    "pt": "Número de telefone do contato local para instalação",
    "ko": "현지 설치 담당자 연락처",
    "it": "N. telefono del contatto per l'installazione locale"
  },
  "Local installation contact name": {
    "en": "",
    "de": "Installationskontakt vor Ort: Name",
    "fr": "Nom : Nom du Contact installation locale",
    "zh": "当地安装联系人电话",
    "es": "Nombre de contacto para instalación",
    "pt": "Nome do contato local para instalação",
    "ko": "현지 설치담당자 성함",
    "it": "Nome del contatto per l'installazione locale"
  },
  "INVOICE INSTRUCTIONS": {
    "en": "",
    "de": "Rechnungsvorgabe",
    "fr": "INSTRUCTIONS de FACTURATION",
    "es": "INSTRUCIONES DE FACTURACIÓN",
    "pt": "Instruções da fatura",
    "zh": "发票说明",
    "it": "Instruzioni fatturazione"
  },
  "Cust Invoice Comments": {
    "en": "",
    "de": "Rechnungskommentar",
    "fr": "Commentaires Facture Client",
    "zh": "客户发票注释",
    "es": "Comentarios de factura del cliente",
    "pt": "Comentários da fatura do cliente",
    "ko": "인보이스 코멘트",
    "it": "Commenti del cliente sulla fattura"
  },
  "OPG": {
    "en": "",
    "de": "OPG",
    "fr": "Numéro OPG",
    "es": "OPG",
    "pt": "OPG",
    "zh": "OPG",
    "ko": "OPG",
    "it": "N. OPG"
  },
  "Web Order Number": {
    "en": "",
    "de": "Web-Bestellnummer",
    "fr": "Numéro de Commande Web",
    "es": "Número de pedido Web",
    "pt": "Número de pedido na Web",
    "zh": "Web Order#",
    "ko": "웹 오더넘버",
    "it": "N. ordine web"
  },
  "Reporting": {
    "en": "",
    "de": "Reporting",
    "fr": "Rapports",
    "es": "Reporteo",
    "pt": "Relatórios",
    "zh": "报表",
    "ko": "리포팅",
    "it": "Reporting"
  },
  "Serial No": {
    "en": "",
    "de": "Seriennummer",
    "fr": "Numéro de série",
    "zh": "序列号",
    "es": "Número de Serie",
    "pt": "Número de série",
    "ko": "시리얼넘버",
    "it": "N. di serie"
  },
  "Ship to Address": {
    "en": "",
    "de": "Lieferadresse Firmenname",
    "fr": "Expédié à la société",
    "zh": "送货地址",
    "es": "Enviar a la dirección",
    "pt": "Endereço de embarque",
    "ko": "배송지"
  },
  "Order under validation": {
    "en": "",
    "de": "Auftrag wird geprüft",
    "zh": "订单审核中",
    "es": "Orden en revisión",
    "fr": "Commande en cours de validation",
    "pt": "Pedido sob validação"
  },
  "Select your report then you will be prompted for your filters": {
    "en": "",
    "es": "Seleccione el reporte y elija los filtros",
    "fr": "Sélectionnez votre rapport et définissez la selection",
    "pt": "Selecione seu relatório e você seguirá para seus filtros",
    "de": "Wählen Sie den Bericht und die entsprechenden Filter",
    "zh": "选择你所需报表来进行筛选"
  },
  "Select the report to be changed or click the output to see the results": {
    "en": "",
    "es": "Seleccione el reporte que desea cambiar o haga clic en el resultado del reporte",
    "fr": "Sélectionnez le rapport a modifier ou cliquer sur le fichier pour voir les resultats",
    "pt": "Selecione o relatório a ser alterado ou clique para ver os resultados",
    "de": "Wählen Sie den zu bearbeitenden Bericht or drücken Sie auf das Ergebnis um es anzuzeigen",
    "zh": "选择要更改的报表或点击结果查看详情"
  },
  "Go to old reporting": {
    "en": "Go to legacy reporting instance",
    "fr": "Aller dans l'ancien système de rapport",
    "es": "Ir a los reportes anteriores",
    "pt": "Ir para relatórios antigos",
    "de": "Zurück zur alten Berichtserstellung",
    "zh": "回到旧版报表页面"
  },
  "Create new report": {
    "en": "",
    "fr": "Créer un nouveau rapport",
    "es": "Crear un nuevo reporte",
    "pt": "Criar novo relatório",
    "zh": "创建新的报表",
    "de": "Neuen Bericht generieren"
  },
  "My report results": {
    "en": "",
    "fr": "Resultats de  mes rapports",
    "es": "Resultado de mis reportes",
    "pt": "Resultados dos meus relatórios",
    "de": "Meine Berichtsergebnisse",
    "zh": "我的报表"
  },
  "search...": {
    "en": "",
    "fr": "Chercher...",
    "es": "Búsqueda",
    "pt": "pesquisa...",
    "zh": "搜索...",
    "de": "suchen..."
  },
  "Report Name": {
    "en": "",
    "fr": "Nom du rapport",
    "es": "Nombre del reporte",
    "pt": "Nome do Relatório",
    "de": "Berichtsname",
    "zh": "报表名称"
  },
  "Schedule": {
    "en": "",
    "fr": "Planifié",
    "es": "Agendar",
    "pt": "Agendar",
    "zh": "定制",
    "de": "Planen"
  },
  "Run": {
    "en": "",
    "fr": "Lancer",
    "es": "Correr",
    "pt": "Executar",
    "zh": "运行",
    "de": "Generieren"
  },
  "Report Output": {
    "en": "",
    "fr": "Format du rapport",
    "es": "Resultado del reporte",
    "pt": "Output do relatório",
    "zh": "导出报表",
    "de": "Berichtsergebnis"
  },
  "Delete": {
    "en": "",
    "fr": "Supprimer",
    "es": "Borrar",
    "pt": "Apagar",
    "zh": "删除",
    "de": "Löschen"
  },
  "On Request": {
    "en": "",
    "fr": "A la demande",
    "es": "Bajo pedido",
    "pt": "A pedido",
    "de": "Auf Anfrage",
    "zh": "应要求"
  },
  "daily": {
    "en": "",
    "fr": "Journalier",
    "es": "Diariamente",
    "pt": "Diariamente",
    "zh": "每天",
    "de": "täglich"
  },
  "weekly": {
    "en": "",
    "fr": "Hebdomadaire",
    "es": "Semanalmente",
    "pt": "Semanalmente",
    "zh": "每周",
    "de": "wöchentlich"
  },
  "monthly": {
    "en": "",
    "fr": "Mensuel",
    "es": "Mensualmente",
    "pt": "Mensalmente",
    "zh": "每月",
    "de": "monatlich"
  },
  "Get Report": {
    "en": "",
    "fr": "Obtenir le rapport",
    "es": "Obtener Reporte",
    "pt": "Obter relatório",
    "zh": "获取报表",
    "de": "Bericht generieren"
  },
  "Define your filters:": {
    "en": "",
    "fr": "Définissez votre selection",
    "es": "Defina los filtros",
    "pt": "Definir filtros:",
    "de": "Filter definieren:",
    "zh": "定义筛选"
  },
  "Add more": {
    "en": "",
    "fr": "Ajouter",
    "es": "Agregar más",
    "pt": "Adicionar mais",
    "zh": "添加更多",
    "de": "Mehr hinzufügen"
  },
  "Apply filters": {
    "en": "",
    "fr": "Appliquer la selection",
    "es": "Aplicar Filtros",
    "pt": "Aplicar filtros",
    "de": "Filter aktivieren",
    "zh": "筛选"
  },
  "Report preview:": {
    "en": "",
    "fr": "Prévisualiser le rapport",
    "es": "Vista previa del reporte",
    "pt": "Previsão do relatório",
    "zh": "报表提前预览",
    "de": "Berichtsvorschau"
  },
  "Add more fields": {
    "en": "",
    "fr": "Ajouter des champs",
    "es": "Agregar más campos",
    "pt": "Adicionar mais campos",
    "de": "Neue Felder hinzufügen",
    "zh": "增加更多项"
  },
  "Loading...": {
    "en": "",
    "fr": "Chargement...",
    "es": "Cargando...",
    "pt": "Carregando...",
    "de": "Daten werden geladen...",
    "zh": "加载..."
  },
  "estimated number of orders:": {
    "en": "",
    "fr": "Nombre de commande estimé",
    "es": "Número estimado de órdenes",
    "pt": "Números estimados da ordem:",
    "de": "geschätzte Anzahl der Bestellungen:",
    "zh": "预计订单数量"
  },
  "Drag and drop field to change column position, click on it to sort": {
    "en": "",
    "fr": "Sélectionner et déplacer pour changer la colonne de position, cliquer pour trier",
    "es": "Arrastre y suelte el campo para cambiar la posición de la columna, haga clic en él para ordenar",
    "pt": "Arraste e solte o campo para mudar a posição da coluna, clique nele para classificar",
    "de": "Drag & Drop der Felder um die Spaltenposition zu verändern, zum Sortieren auf die Spalte drücken",
    "zh": "拖动标题以更改显示次序"
  },
  "Customize Report Columns": {
    "en": "",
    "fr": "Configurer les colonnes du rapport",
    "es": "Personalizar las columnas del reporte",
    "pt": "Colunas Selecionadas",
    "de": "Berichtsspalten anpassen",
    "zh": "自定义报表的列"
  },
  "Selected Columns": {
    "en": "",
    "fr": "Colonnes selectionnées",
    "es": "Columnas seleccionadas",
    "pt": "Colunas Selecionadas",
    "de": "Ausgewählte Spalten",
    "zh": "选中的列"
  },
  "Available Columns": {
    "en": "",
    "fr": "Colonnes disponibles",
    "es": "Columnas disponibles",
    "pt": "Colunas Disponíveis",
    "de": "Verfügbare Spalten",
    "zh": "可用的列"
  },
  "Save": {
    "en": "",
    "fr": "Sauvegarder",
    "es": "Guardar",
    "pt": "Salvar",
    "zh": "保存",
    "de": "Speichern"
  },
  "Save and run": {
    "en": "",
    "fr": "Sauvegarder et lancer",
    "es": "Guardar y correr",
    "pt": "Salvar e executar",
    "zh": "保存并运行",
    "de": "Speichern und generieren"
  },
  "Save or schedule your report": {
    "en": "",
    "fr": "Sauvegarder ou planifier votre rapport ",
    "es": "Guardar o agendar el reporte",
    "pt": "Salvar ou agendar seu relatório",
    "zh": "保存或定制报表",
    "de": "Bericht speichern oder regelmässig aufsetzen"
  },
  "Name your report": {
    "en": "",
    "fr": "Nom du rapport",
    "es": "Nombrar el reporte",
    "pt": "Nomear seu relatório",
    "de": "Geben Sie dem Bericht einen Namen",
    "zh": "给您的报表命名"
  },
  "give the report a name...": {
    "en": "",
    "fr": "Donner un nom au rapport",
    "es": "Dar un nombre al reporte",
    "pt": "Dê um nome ao relatório...",
    "de": "Geben Sie dem Bericht einen Namen...",
    "zh": "给您的报表命名"
  },
  "Describe your report": {
    "en": "",
    "fr": "Description du rapport",
    "es": "Describir reporte",
    "pt": "Descrição do relatório",
    "de": "Bericht beschreiben",
    "zh": "描述你的报表"
  },
  "Choose output format": {
    "en": "",
    "fr": "Format du rapport",
    "es": "Elija el formato",
    "pt": "Escolha o formato do relatório",
    "de": "Ergebnisformat auswählen",
    "zh": "选择输出格式"
  },
  "tab separated file": {
    "en": "",
    "fr": "Fichier séparé par des tabulations",
    "es": "Archivo separado por tabs",
    "pt": "arquivo separado por abas",
    "zh": "选项卡拆分出来的文档",
    "de": "Tab getrenntes Format"
  },
  "CSV file": {
    "en": "",
    "fr": "Fichier séparé par des virgules",
    "es": "Archivo CSV",
    "pt": "Arquivo CSV",
    "zh": "CSV 文件",
    "de": "CSV Format"
  },
  "XLSX Excel file": {
    "en": "",
    "fr": "Fichier excel .XLSX",
    "es": "Archivo Excel XLSX",
    "pt": "Arquivo XLSX Excel",
    "zh": "XLSX Excel 文件",
    "de": "XLSX Excel Format"
  },
  "Excel/html file (with auto-filter)": {
    "en": "",
    "fr": "Fichier excel/html avec filtres",
    "es": "Archivo Excel/HTML (sin auto-filtro)",
    "pt": "Arquivo Excel/html (com auto-filtro)",
    "de": "Excel/ html file (mit automatischen Filtern)",
    "zh": "Excel格式"
  },
  "Send output via Email": {
    "en": "",
    "fr": "Envoyer le rapport par messagerie",
    "es": "Enviar el reporte por correo",
    "pt": "Enviar relatório via e-mail",
    "de": "Ergebnis als Anhang einer Email versenden",
    "zh": "通过邮件发送"
  },
  "send results as attachment via email to:": {
    "en": "",
    "fr": "Envoyer les résultats en piece jointe d'un email à :",
    "es": "Envíe los resultados como adjuntos por correo electrónico a:",
    "pt": "Enviar os resultados do relatório como arquivo via e-mail para:",
    "de": "Ergebnis als Anhang einer Email versenden an:",
    "zh": "将结果以邮件附件的形式发送到:"
  },
  "new email address to add": {
    "en": "",
    "fr": "Nouvelle adresse email à ajouter",
    "es": "Agregar nueva dirección de correo electrónico",
    "pt": "novo endereço de e-mail para adicionar",
    "zh": "添加新的邮箱地址",
    "de": "Neue Emailadresse hinzufügen"
  },
  "Add": {
    "en": "",
    "fr": "Ajouter",
    "es": "Agregar",
    "pt": "Adicionar",
    "zh": "添加",
    "de": "Hinzufügen"
  },
  "Schedule your report": {
    "en": "",
    "fr": "Planifier votre rapport",
    "es": "Agendar el reporte",
    "pt": "Agendar seu relatório",
    "zh": "定制你的报表",
    "de": "Bericht regelmässig erstellen"
  },
  "run now": {
    "en": "",
    "fr": "Lancer maintenant",
    "es": "Correr ahora",
    "pt": "Executar agora",
    "de": "jetzt generieren",
    "zh": "现在运行"
  },
  "schedule regularly": {
    "en": "",
    "fr": "Planifier periodiquement",
    "es": "Agendar con regularidad",
    "pt": "Agendar regularmente",
    "de": "regelmässig aufsetzen",
    "zh": "定时跑报表"
  },
  "interval:": {
    "en": "",
    "fr": "Periode",
    "es": "Intervalo:",
    "pt": "intervalo:",
    "zh": "间距",
    "de": "Intervall:"
  },
  "start time:": {
    "en": "",
    "fr": "Heure de démarrage",
    "es": "Inicio:",
    "pt": "hora de início:",
    "zh": "开始时间",
    "de": "Startzeitpunkt"
  },
  "my local timezone": {
    "en": "",
    "fr": "Mon heure locale",
    "es": "Mi hora local",
    "pt": "meu fuso horário local",
    "zh": "当地时区",
    "de": "Meine lokale Zeitzone"
  },
  "Greenwich Mean Time": {
    "en": "",
    "fr": "GMT",
    "es": "Hora en el meridiano de Greenwich",
    "pt": "Horário de Greenwich",
    "zh": "格林威治标准时间",
    "de": "Greenwich-Zeit"
  },
  "Do you want to delete this report including results?": {
    "en": "",
    "fr": "Voulez vous supprimer ce rapport et les résultats ?",
    "es": "¿Desea eliminar este reporte incluyendo los resultados?",
    "pt": "Você quer deletar este relatório incluindo resultados?",
    "de": "Möchten Sie diesen Report und die Ergebnisse löschen?",
    "zh": "您想删除该报表吗"
  },
  "run report now": {
    "en": "",
    "fr": "Lancer le rapport maintenant",
    "de": "Bericht jetzt generieren",
    "es": "Correr el reporte ahora",
    "pt": "Executar relatório agoa",
    "zh": "现在运行报表"
  },
  "Monday": {
    "en": "",
    "fr": "Lundi",
    "zh": "周一",
    "es": "Lunes",
    "de": "Montag",
    "pt": "Segunda-feira"
  },
  "Tuesday": {
    "en": "",
    "fr": "Mardi",
    "zh": "周二",
    "es": "Martes",
    "de": "Dienstag",
    "pt": "Terça-feira"
  },
  "Wednesday": {
    "en": "",
    "fr": "Mercredi",
    "zh": "周三",
    "es": "Miércoles",
    "de": "Mittwoch",
    "pt": "Quarta-feira"
  },
  "Thursday": {
    "en": "",
    "fr": "Jeudi",
    "zh": "周四",
    "es": "Jueves",
    "de": "Donnerstag",
    "pt": "Quinta-feira"
  },
  "Friday": {
    "en": "",
    "fr": "Vendredi",
    "zh": "周五",
    "es": "Viernes",
    "de": "Freitag",
    "pt": "Sexta-feira"
  },
  "Saturday": {
    "en": "",
    "fr": "Samedi",
    "zh": "周六",
    "es": "Sábado",
    "de": "Samstag",
    "pt": " Sábado"
  },
  "Sunday": {
    "en": "",
    "fr": "Dimanche",
    "zh": "周日",
    "es": "Domingo",
    "de": "Sonntag",
    "pt": "Domingo"
  },
  "Company Name": {
    "en": "",
    "es": "Nombre de la compañía",
    "pt": "Nome da Empresa",
    "de": "Firmenname des Käufers",
    "zh": "Sold To 公司名"
  },
  "Only first 2000 rows are shown": {
    "en": "",
    "de": "Nur die ersten 2000 Zeilen werden angezeigt!",
    "es": "Solo se muestran las primeras 2000 filas",
    "zh": "只显示前2000行",
    "pt": "Apenas as primeiras 2000 linhas são mostradas"
  },
  "Order Book Report": {
    "en": "",
    "de": "Auftragsübersicht",
    "es": "Reporte de órdenes",
    "zh": "订单报表",
    "pt": "Relatório da Ordem"
  },
  "All order details with status": {
    "en": "",
    "de": "Alle Auftragsdetails mit Status",
    "es": "Todos los detalles de la orden con estatus",
    "zh": "所有订单详情与状态",
    "pt": "Todos os detalhes das ordens com status"
  },
  "Detail Report with technical info": {
    "en": "",
    "de": "Detaillierter Bericht mit Technischen Daten",
    "es": "Reporte detallado con información técnica",
    "zh": "产品信息报表",
    "pt": "Relatório detalhado com informações técnicas"
  },
  "Technical data about units shipped (Serial number, mac@,...)": {
    "en": "",
    "de": "Technische Daten versendeter Produkte (Seriennummern, Mac-Adressen,...)",
    "es": "Datos técnicos sobre las unidades enviadas (número de serie, mac @, ...)",
    "zh": "已发货货物的产品信息（序列号，Mac 地址等）",
    "pt": "Dados técnicos sobre unidades embarcadas (número de série, etc.)"
  },
  "Shipment / Delivery Report": {
    "en": "",
    "de": "Versand/ Anlieferungsbericht",
    "es": "Reporte de Envío / Entrega",
    "zh": "发货/送货报表",
    "pt": "Relatório de Entrega/Embarque"
  },
  "All orders shipped with logistic details (Shipment number / box)": {
    "en": "",
    "de": "Alle Aufträge im Versand mit Logistikinformationen (Versandnummer, Box)",
    "es": " Todos las órdenes enviadas con detalles logísticos (número de envío / caja)",
    "zh": "所有已发货订单的物流信息（运单号，箱号等）",
    "pt": "Ordens embarcadas com detalhes logísticos (número de embarque/caixa)"
  },
  "OrderType": {
    "en": "",
    "de": "",
    "es": "Tipo de orden",
    "zh": "订单类型",
    "pt": "Tipo de Ordem"
  },
  "No manufacturing data found": {
    "en": "",
    "zh": "找不到产品信息",
    "es": "No se encontraron datos de fabricación",
    "pt": "Nenhum dado de fabricação encontrado"
  },
  "Too many rows! Limit of 100,000 lines reached!": {
    "en": "",
    "zh": "数据太多！已达到100,000条上限！",
    "es": "¡Demasiadas líneas! ¡Límite de 100,000 alcanzadas!",
    "pt": "Muitas linhas! Limite de 100.000 linhas alcançadas!"
  },
  "Please contact your distributor to retrieve this invoice": {
    "en": "",
    "zh": "请联系您的经销商来获得发票",
    "es": "Póngase en contacto con su distribuidor para recuperar esta factura",
    "pt": "Entre em contato com seu distribuidor para recuperar esta fatura"
  },
  "Search orders based on serialized products": {
    "en": "Search orders with products manufactured and having Serial Numbers assigned",
    "zh": "通过产品号搜索订单",
    "es": "Buscar órdenes basadas en productos serializados",
    "pt": "Busca de ordens baseado em produtos serializados"
  },
  "HP Order No": {
    "en": "",
    "zh": "惠普订单号(F4XA/Z100开头)",
    "es": "Número de orden HP",
    "pt": "Número da ordem HP"
  },
  "Shipment No": {
    "en": "",
    "zh": "运单号",
    "es": "Número de envío",
    "pt": "Número de embarque"
  },
  "HP Product Number": {
    "en": "",
    "zh": "HP产品号",
    "es": "Número de producto HP",
    "pt": "Código de produto HP"
  },
  "Sensitive information – please login via the HP portal to view this!": {
    "en": "",
    "es": "Información confidencial: inicie sesión a través del portal de HP para ver esto.",
    "pt": "Informação confidencial – Por favor, faça login no Portal HP para ver isto!"
  },
  "warn_details_same_filter": {
    "en": "Please use different filtering criteria  !",
    "es": "Detalles de advertencia, mismo filtro",
    "pt": "Detalhes do aviso – mesmo filtro"
  },
  "warn_details_empty_additional_filter": {
    "en": "Please fill in the empty filtering criteria !",
    "es": "Detalles de advertencia:  filtro adicional vacío",
    "pt": "Detalhes do aviso – filtro adicional vazio"
  },
  "Order Search Guide": {
    "en": "",
    "es": "Guía para búsqueda de órdenes",
    "pt": "Guia de busca de ordens"
  },
  "Reporting Guide": {
    "en": "",
    "es": "Guía de reportes",
    "pt": "Guia de relatórios"
  },
  "New OSS User Interface Tutorial": {
    "en": "",
    "es": "Tutorial del nuevo interfaz de usuario de OSS",
    "pt": "Tutorial de interface do OSS para novo usuário"
  },
  "Provide Feedback": {
    "en": "",
    "es": "Denos su opinión",
    "pt": "Enviar feedback"
  },
  "Multiple orders found - Please select:": {
    "en": "",
    "es": "Múltiples órdenes encontradas - Por favor seleccione:",
    "pt": "Múltiplas ordens encontradas - Por favor, selecione:"
  },
  "Tracking No": {
    "en": "",
    "es": "Número de rastreo",
    "pt": "Número de embarque",
    "de": ""
  },
  "Quick Search (single value)": {
    "en": "",
    "es": "Búsqueda rápida (solo un valor)",
    "pt": "Busca rápida (único valor)"
  },
  "Web Order No": {
    "en": "",
    "es": "Número de orden web",
    "pt": "Número de pedido Web"
  },
  "Current Month": {
    "en": "",
    "es": "Mes actual",
    "pt": "Mês atual",
    "de": "Aktueller Monat"
  },
  "show all order types": {
    "en": "",
    "es": "mostrar todos los tipos de orden",
    "pt": "Mostrar todos os tipos de ordem"
  },
  "show records per order": {
    "en": "",
    "es": "mostrar registros por orden",
    "pt": "Mostrar registros por ordem"
  },
  "Order Data": {
    "en": "",
    "es": "Datos de la orden",
    "pt": "Dados da ordem"
  },
  "Item Data": {
    "en": "",
    "es": "Datos del artículo",
    "pt": "Dados do item"
  },
  "Export Data by Pre-Defined Template": {
    "en": "",
    "es": "Exportar datos por formato predefinido",
    "pt": "Exportar dados por template pré-definido"
  },
  "Export Data as shown below": {
    "en": "",
    "es": "Exportar datos como se muestra a continuación",
    "pt": "Exportar dados conforme abaixo"
  },
  "all": {
    "en": "",
    "es": "todo",
    "pt": "Tudo"
  },
  "No lastOrdersViewed order available": {
    "en": "",
    "es": "No hay órdenes disponibles",
    "pt": "Nenhuma ordem disponível"
  },
  "searchField": {
    "en": "",
    "es": "campo de búsqueda",
    "pt": "Campo de busca"
  },
  "All order details with status ": {
    "en": "",
    "es": "Todos los detalles de la orden con su status",
    "pt": "Todas as ordens com status"
  },
  "Date Validation Error": {
    "en": "",
    "es": "Error de validación de fecha",
    "pt": "Erro de validação de data"
  },
  "Please check the areas highlighted in red for date format errors": {
    "en": "",
    "es": "Por favor, compruebe las áreas resaltadas en rojo para los errores de formato de fecha",
    "pt": "Por favor, verifique os campos em vermelho para erros no formato da data"
  },
  "give the report description ...": {
    "en": "",
    "es": "proporcione la descripción del reporte ...",
    "pt": "Dar a descrição do relatório"
  },
  "ShipToRegion": {
    "en": "",
    "es": "Embarque por región",
    "pt": "Região de embarque"
  },
  "ShipToCountry": {
    "en": "",
    "es": "Embarque por país",
    "pt": "País de embarque"
  },
  "IsMainItem": {
    "en": "",
    "es": "Artículo principal",
    "pt": "É item principal"
  },
  "HPReceiveDate": {
    "en": "",
    "es": "Fecha en que HP recibe",
    "pt": "Data de recebimento na HP"
  },
  "yesterday": {
    "en": "",
    "es": "Ayer",
    "pt": "Ontem",
    "de": "Gestern"
  },
  "today": {
    "en": "",
    "es": "Hoy",
    "pt": "Hoje",
    "de": "Heute"
  },
  "tomorrow": {
    "en": "",
    "es": "Mañana",
    "pt": "Amanhã",
    "de": "Morgen"
  },
  "last week": {
    "en": "",
    "es": "La Semana Pasada",
    "pt": "Última semana",
    "de": "letzte Woche"
  },
  "current week": {
    "en": "",
    "es": "Semana actual",
    "pt": "Semana atual",
    "de": "aktuelle Woche"
  },
  "next week": {
    "en": "",
    "es": "La próxima semana",
    "pt": "Próxima semana",
    "de": "nächste Woche"
  },
  "last month": {
    "en": "",
    "es": "El mes pasado",
    "pt": "Último mês",
    "de": "letzter Monat"
  },
  "next month": {
    "en": "",
    "es": "El próximo mes",
    "pt": "Próximo mês",
    "de": "nächster Monat"
  },
  "last 3 months": {
    "en": "",
    "es": "Últimos 3 meses",
    "pt": "Últimos 3 meses",
    "de": "letzten 3 Monate"
  },
  "custom range": {
    "en": "",
    "es": "Personalizar rango",
    "pt": "Intervalo customizado",
    "de": "benutzerdefiniert"
  },
  "DownloadShipmentDataToolTip": {
    "en": "",
    "es": "Descargar la herramienta de los datos de envío",
    "pt": "Baixar dados do embarque"
  },
  "Download Shipment Details": {
    "en": "",
    "es": "Descargar detalles del envío",
    "pt": "Baixar dados do embarque"
  },
  "Shipment(s)": {
    "en": "",
    "es": "Envío(s)",
    "pt": "Embarques"
  },
  "Mfg<br>Data": {
    "en": "",
    "pt": "Dados de Manufatura",
    "es": "Datos de manufactura"
  },
  "Download all Item details": {
    "en": "",
    "es": "Descargue todos los detalles del artículo",
    "pt": "Baixar todos os detalhes do item"
  },
  "Download Manufacturing Details": {
    "en": "",
    "es": "Descargar detalles de fabricación",
    "pt": "Baixar datalhes de manufatura"
  },
  "Manufacturing Data": {
    "en": "",
    "es": "Datos de fabricación",
    "pt": "Dados de Manufatura"
  },
  "Payment Terms": {
    "en": "",
    "es": "Términos de pago",
    "pt": "Condições de Pagamento"
  },
  "Localization": {
    "en": "",
    "es": "Localización",
    "pt": "Localização"
  },
  "Ship to Address and Contact": {
    "en": "",
    "zh": "发货地址及联系人",
    "es": "Dirección de envío y contacto",
    "pt": "Endereço de entrega e contato"
  },
  "Only first 2000 orders are shown": {
    "en": "",
    "pt": "Apenas as primeiras 2000 ordens são exibidas",
    "es": "Solo se muestran las primeras 2000 órdenes"
  },
  "rows": {
    "en": "",
    "pt": " linhas",
    "es": "Líneas",
    "de": "Zeilen"
  },
  "Customize Columns": {
    "en": "",
    "pt": "Personalizar Colunas",
    "es": "Personalizar Columnas"
  },
  "Standard Columns": {
    "en": "",
    "pt": "Colunas Padrão",
    "es": "Columnas estándar"
  },
  "In order to view the recently added columns click again on the same dashboard number value or on the Search button, new columns will be displayed across.": {
    "en": "",
    "pt": "Para visualizar as colunas adicionadas recentemente, clique novamente no mesmo valor numérico do painel ou no botão Pesquisar, novas colunas serão exibidas.",
    "es": "Para ver las columnas agregadas recientemente, haga clic de nuevo en el mismo valor de número del tablero o en el botón Buscar, se mostrarán nuevas columnas."
  },
  "Ship To Company": {
    "en": "",
    "pt": "Cliente para envio",
    "es": "Cliente de envío"
  },
  "Order Status": {
    "en": "",
    "pt": "Status da Ordem",
    "es": "Estado de la orden"
  },
  "Order Type Detail": {
    "en": "",
    "pt": "Detalhes da Ordem",
    "es": "Detalles de la orden"
  },
  "Ship To Attention": {
    "en": "",
    "pt": "Aos cuidados de",
    "es": "A los cuidados de"
  },
  "Ship To Region": {
    "en": "",
    "pt": "Região para envio",
    "es": "Región de Envío"
  },
  "Export limit of": {
    "en": "",
    "pt": "Limite de exportação de dados",
    "es": "Límite de exportación"
  },
  "rows reached": {
    "en": "",
    "pt": "Linhas alcançadas",
    "es": "Líneas alcanzadas"
  },
  "Ordered Quantity": {
    "en": "",
    "pt": "Quantidade da ordem",
    "es": "Cantidad ordenada"
  },
  "Shipped Quantity": {
    "en": "",
    "pt": "Quantidade embarcada",
    "es": "Cantidad enviada"
  },
  "Shipment Number": {
    "en": "",
    "pt": "Número de Embarque",
    "es": "Numero de envío"
  },
  "Bill of Lading": {
    "en": "",
    "pt": "Conhecimento de Embarque",
    "es": "Número de Embarque"
  },
  "Bundle ID": {
    "en": "",
    "pt": "Bundle ID",
    "es": "Bundle ID"
  },
  "Carrier Delivery Number": {
    "en": "",
    "pt": "Número de entrega da transportadora",
    "es": "Número de entrega del transportista"
  },
  "Config ID": {
    "en": "",
    "pt": "Config ID",
    "es": "ID de configuración"
  },
  "End Customer Name": {
    "en": "",
    "pt": "Nome do cliente final",
    "es": "Nombre del cliente final"
  },
  "Exception": {
    "en": "",
    "pt": "Exceção",
    "es": "Excepción"
  },
  "Net Invoice Price": {
    "en": "",
    "pt": "Valor total da fatura sem impostos em dólares",
    "es": "Precio total de la factura"
  },
  "Net Line Dollar Price": {
    "en": "",
    "pt": "Valor total da linha sem impostos em dólares",
    "es": "Precio neto de la línea en dólares"
  },
  "Net Order Dollar Price": {
    "en": "",
    "pt": "Valor total da ordem sem impostos em dólares",
    "es": "Precio neto de laorden en dólares"
  },
  "Net Order Price": {
    "en": "",
    "pt": "Valor total da ordem sem impostos ",
    "es": "Precio neto de la orden"
  },
  "Net Unit Dollar Price": {
    "en": "",
    "pt": "Valor unitário sem impostos em dólares",
    "es": "Valor unitario en dólares"
  },
  "Net Unit Price": {
    "en": "",
    "pt": "Valor unitário sem impostos",
    "es": "Valor unitario"
  },
  "OPG Code": {
    "en": "",
    "pt": "Código da OPG",
    "es": "Código OPG"
  },
  "Product Family": {
    "en": "",
    "pt": "Família do Produto",
    "es": "Familia del producto"
  },
  "Quote Number": {
    "en": "",
    "pt": "Número da Quote",
    "es": "Número de cotización"
  },
  "Ref Model ID": {
    "en": "",
    "pt": "ID do modelo de referência",
    "es": "ID del modelo de referencia"
  },
  "Open Quantity": {
    "en": "",
    "pt": "Quantidade em aberto",
    "es": "Cantidad abierta"
  },
  "Ship To City": {
    "en": "",
    "pt": "Cidade de envio",
    "es": "Ciudad de envío"
  },
  "Total Order Price": {
    "en": "",
    "pt": "Valor Total da Ordem",
    "es": "Precio total de la orden"
  },
  "Tracking Number": {
    "en": "",
    "pt": "Número de embarque",
    "es": "Número de rastreo",
    "de": "Sendungsnummer"
  },
  "": {
    "en": ""
  },
  "Estimated Deliver Date": {
    "en": "",
    "de": "Voraussichtliches Lieferdatum",
    "es": "Fecha estimada de entrega",
    "fr": "Date de livraison estimée",
    "it": "Data di consegna stimata",
    "sv": "Beräknat leveransdatum",
    "nl": "Geschatte leveringsdatum"
  },
  "Price (excluding VAT)": {
    "en": "",
    "de": "Preis (ohne MwSt.)",
    "es": "Precio (sin IVA)",
    "fr": "Prix HT",
    "it": "Prezzo (IVA esclusa)",
    "sv": "Pris (exklusive moms)",
    "nl": "Prijs (exclusief btw)"
  },
  "Subtotal": {
    "en": "",
    "de": "Zwischensumme",
    "es": "Total parcial",
    "fr": "Sous-total",
    "nl": "Subtotaal",
    "it": "\tTotale parziale"
  },
  "VAT": {
    "en": "",
    "de": "Mehrwertsteuer",
    "es": "IVA",
    "fr": "TVA",
    "nl": "BTW",
    "it": "IVA"
  },
  "Total (including VAT)": {
    "en": "",
    "de": "Summe (einschließlich Mehrwertsteuer)",
    "es": "Total (IVA incluido)",
    "fr": "Total TTC",
    "nl": "Totaal (inclusief btw)",
    "it": "Totale (IVA inclusa)"
  },
  "SCNA": {
    "en": "Not applicable",
    "it": ""
  },
  "PA / Gov Contract": {
    "en": ""
  },
  "SIN": {
    "en": "Singapore",
    "de": "Singapur"
  },
  "CONLEY": {
    "en": "cross-dock warehouse",
    "de": "Cross Dock Warenlager"
  },
  "ICN": {
    "en": "SEOUL AIRPORT",
    "de": "Seoul Flughafen"
  },
  "USCZU": {
    "en": "cross-dock warehouse",
    "de": "Cross Dock Warenlager"
  },
  "SOUTH GATE": {
    "en": "cross-dock warehouse",
    "de": "Cross Dock Warenlager"
  },
  "USSGC": {
    "en": "cross-dock warehouse",
    "de": "Cross Dock Warenlager"
  },
  "ROMELVILLE": {
    "en": "cross-dock warehouse",
    "de": "Cross Dock Warenlager"
  },
  "crossDockIcon": {
    "en": "major hand over  logistic milestone",
    "de": "Wichtiger logistischer Haltepunkt"
  },
  "DHAE": {
    "en": ""
  },
  "ROMEOVILLE": {
    "en": "cross-dock warehouse",
    "de": "Cross Dock Warenlager"
  },
  "GRPIR": {
    "en": "Piraeus port"
  },
  "PIR": {
    "en": "Piraeus port"
  },
  "DEHXE": {
    "en": "Huenxe warehouse"
  },
  "NLRTM": {
    "en": "Rotterdam port",
    "de": "Hafen Rotterdam"
  },
  "Piraeus": {
    "en": "Piraeus port"
  },
  "AEJEA": {
    "en": "Jebel Ali port"
  },
  "JEA": {
    "en": "Jebel Ali port"
  },
  "DXB": {
    "en": "Dubai airport"
  },
  "ZJF": {
    "en": "Dubai airport"
  },
  "LAX": {
    "en": "Los Angeles airport"
  },
  "crossDockImage": {
    "en": "Major handover logistic milestone"
  },
  "May not display all orders that will be included in your report output": {
    "en": ""
  },
  "ReportingDisclaimerText": {
    "en": " (Below preview is only a sample. The generated report will contain the complete data.)",
    "fr": "La vue ci-dessous est un exemple. Le rapport généré contiendra toutes les données attendues"
  },
  "Estimated delivery date": {
    "en": "",
    "de": "Voraussichtliches Lieferdatum",
    "es": "Fecha estimada de entrega",
    "fr": "Date de livraison estimée",
    "it": "Data di consegna stimata",
    "sv": "Beräknat leveransdatum",
    "nl": "Geschatte leveringsdatum"
  },
  "Prices without Tax": {
    "en": "",
    "de": "Preis (ohne MwSt.)",
    "es": "Precio (sin IVA)",
    "fr": "Prix HT",
    "it": "Prezzo (IVA esclusa)",
    "sv": "Pris (exklusive moms)",
    "nl": "Prijs (exclusief btw)"
  },
  "ORDER INFORMATION": {
    "en": "",
    "fr": "VOTRE COMMANDE",
    "de": "Bestellinformation"
  },
  "Estimated Delivery Date": {
    "en": "",
    "de": "Voraussichtliches Lieferdatum",
    "es": "Fecha estimada de entrega",
    "fr": "Date de livraison estimée",
    "it": "Data di consegna stimata",
    "sv": "Beräknat leveransdatum",
    "nl": "Geschatte leveringsdatum"
  },
  "*Prices without Tax": {
    "en": "",
    "fr": "Prix HT"
  },
  "ADDRESS INFORMATION": {
    "en": "",
    "fr": "ADRESSES",
    "de": "Adressangaben"
  },
  "widget_price_tab_item": {
    "en": "Item"
  },
  "widget_price_tab_description": {
    "en": "Description"
  },
  "widget_price_tab_orderedQty": {
    "en": "Ordered Qty"
  },
  "widget_price_tab_openQty": {
    "en": "Partial Qty"
  },
  "widget_price_tab_list_price": {
    "en": "List Price"
  },
  "widget_price_tab_sales_discount": {
    "en": "Sales Discount"
  },
  "widget_price_tab_contractual_discount": {
    "en": "Contractual Discount"
  },
  "widget_price_tab_shipping_charges": {
    "en": "Shipping Charges"
  },
  "widget_price_tab_fees_value": {
    "en": "Fees"
  },
  "widget_price_tab_other_prices": {
    "en": "Other"
  },
  "widget_price_tab_net_price": {
    "en": "Net"
  },
  "widget_price_tab_tax_value": {
    "en": "Tax"
  },
  "widget_price_tab_total_list_price": {
    "en": "Total List Price"
  },
  "widget_price_tab_total_discounts": {
    "en": "Total Discounts"
  },
  "widget_price_tab_total_net_price": {
    "en": "Total Net"
  },
  "widget_price_tab_total_shipping_charges": {
    "en": "Total Shipping Charges (incl.)"
  },
  "widget_price_tab_total_tax_value": {
    "en": "Total Tax"
  },
  "widget_price_tab_total_fees_value": {
    "en": "Total Fees (incl.)"
  },
  "widget_price_tab_total_order": {
    "en": "Total"
  },
  "sdgItem_item_subitem": {
    "en": "Item"
  },
  "sdgItem_material_no": {
    "en": "Product"
  },
  "sdgItem_prod_localization": {
    "en": "Localization"
  },
  "sdgItem_cust_product_no": {
    "en": "Customer Product"
  },
  "sdgItem_product_descr": {
    "en": "Description"
  },
  "sdgItem_status": {
    "en": "Status"
  },
  "sdgItem_plant_code": {
    "en": "Plant"
  },
  "sdgItem_supplier": {
    "en": "Supplier"
  },
  "sdgItem_delivery_prio": {
    "en": "Delivery Prio"
  },
  "sdgItem_bundle_price": {
    "en": "Bundle Price"
  },
  "sdgItem_stati": {
    "en": "User Status"
  },
  "sdgItem_so_line_item_qty": {
    "en": "Order Qty"
  },
  "sdgItem_sched_line_qty": {
    "en": "Qty"
  },
  "sdgItem_shipped_qty": {
    "en": "Shipped Qty"
  },
  "sdgItem_sc_commit_date": {
    "en": "SC Commit Date"
  },
  "sdgItem_sched_ship_date": {
    "en": "Planned Ship Date"
  },
  "sdgItem_item_pgi_actual": {
    "en": "Factory Ship Date"
  },
  "sdgItem_eshp_actual": {
    "en": "Ship Date"
  },
  "sdgItem_shipment_no": {
    "en": "Shipment"
  },
  "sdgItem_special_codes_item": {
    "en": "Special Codes"
  },
  "sdgItem_invoice_no": {
    "en": "Invoice"
  },
  "sdgItem_sched_delv_date": {
    "en": "Planned Delv Date"
  },
  "sdgItem_pod_at": {
    "en": "POD Date"
  },
  "sdgItem_tsd": {
    "en": "TSD"
  },
  "sdgItem_tdd": {
    "en": "TDD",
    "de": ""
  },
  "Sold to Address": {
    "en": "",
    "de": "Kundenadresse",
    "fr": "Adresse de commande",
    "es": "Vendido a",
    "it": "Indirizzo di Vendita",
    "nl": "Verkocht aan",
    "sv": "Kundadress"
  },
  "Certificate Number": {
    "en": "",
    "de": "HP Care Pack Seriennummer",
    "fr": "Numéro de certificat",
    "es": "Certificado número",
    "it": "Numero certificato",
    "nl": "Certificaatnummer",
    "sv": "Certifikatnummer"
  },
  "Your Order Summary": {
    "en": "",
    "de": "Bestellinformationen",
    "fr": "Détail de votre commande",
    "es": "Resumen de pedido",
    "it": "Riepilogo ordine",
    "nl": "Besteloverzicht",
    "sv": "Sammanställning av order"
  },
  "Cancelled Order Summary": {
    "en": "",
    "de": "Zusammenfassung der stornierten Bestellung",
    "fr": "Résumé de la commande annulée",
    "es": "Resumen de pedido cancelado",
    "it": "Riepilogo dell'ordine annullato",
    "nl": "Overzicht geannuleerde bestelling",
    "sv": "Sammanfattning av avbruten beställning"
  },
  "HP Care Pack Details": {
    "en": "",
    "de": "HP Care Pack Beschreibung",
    "fr": "Détails de HP Care Pack",
    "es": "Detalles de HP Care Pack",
    "it": "Dettagli di HP Care Pack",
    "nl": "HP Care Pack details",
    "sv": "Information om HP Care Pack"
  },
  "Cases": {
    "en": "Support Requests"
  },
  "3W Cases": {
    "en": ""
  },
  "Waiting Customer Update": {
    "en": "Waiting Customer Update"
  },
  "Updated by Customer": {
    "en": "Updated by Customer"
  },

  
  "chevron_shippedToCustomer": {
    "en": "Shipped To Customer"
  },
  "chevron_awaitingReturn": {
    "en": "Awaiting Return"
  },
  "chevron_shipmentScheduled": {
    "en": "Shipment Scheduled"
  },
  "chevron_processing": {
    "en": "Processing"
  },
  "chevron_production": {
    "en": "Production"
  },
  "chevron_consolidation": {
    "en": "Consolidation"
  },
  "chevron_submitted": {
    "en": "Submitted"
  },
  "chevron_completed": {
    "en": "Completed"
  },
  "chevron_accepted": {
    "en": "Processing"
  },
  "chevron_delivered": {
    "en": "Delivered"
  },
  "chevron_canceled": {
    "en": "Canceled"
  },
  "chevron_received": {
    "en": "Received"
  },
  "quote_cust_req": {
    "en": "Requested by Customer"
  },
  "quote_partner_rej": {
    "en": "Rejected by Partner (no action)"
  },
  "quote_partner_prop": {
    "en": "Updated by Partner"
  },
  "quote_cust_rej": {
    "en": "Rejected by Customer"
  },
  "quote_cust_app": {
    "en": "Approved by Customer"
  },
  "quote_partner_sub": {
    "en": "Submitted by Partner (no action)"
  },
  "onetime key is not valid": {
    "en": "This link has expired (15 calendar days since you received the email). Please contact your Customer Operations Specialist to get an updated order status !"
  },
  "chevron_shipmentCanceled": {
    "en": "Shipment Canceled"
  },
  "chevron_pending": {
    "en": "Pending"
  },
  "chevron_active": {
    "en": "Active"
  },
  "chevron_planned": {
    "en": "Planned"
  },
  "chevron_expired": {
    "en": "Expired"
  },
  "New Order Total": {
    "sv": "TOTALBELOPP FÖR NY BESTÄLLNING"
  },
  "certificate_number": {
    "en": "Certificate Number"
  },
  "alert_bucket": {
    "en": "Alert/ Bucket"
  },
  "traffic_light": {
    "en": "Traffic Light"
  },
  "openBlockedServicesDescription": {
    "en": "Items blocked from invoicing with warranty or compatibility errors."
  },
  "openBlockedServicesGreenDescription": {
    "en": "Order was received within the last 3 workdays."
  },
  "openBlockedServicesYellowDescription": {
    "en": "Order was received between 4 and 7 workdays ago."
  },
  "openBlockedServicesRedDescription": {
    "en": "Order was received more than 7 workdays ago."
  },
  "registrationErrorDescriptions": {
    "en": "Failed Care Pack registration after invoicing."
  },
  "registrationErrorGreenDescriptions": {
    "en": "Item invoice date within last 10 workdays."
  },
  "registrationErrorYellowDescriptions": {
    "en": "Item invoice date between 10-20 working days ago."
  },
  "registrationErrorRedDescriptions": {
    "en": "Item invoice date more than 20 workdays ago."
  },
  "deRegisteredServicesDescription": {
    "en": "Service not registered to a hardware serial number."
  },
  "deRegisteredServicesGreenDescription": {
    "en": "Item invoice date within last 10 workdays."
  },
  "deRegisteredServicesYellowDescription": {
    "en": "Item invoice date between 11 and 20 workdays ago."
  },
  "deRegisteredServicesRedDescription": {
    "en": "Item invoice date over 20 workdays ago."
  },
  "serviceExpirationDescription": {
    "en": "Upcoming service expiration date in the coming 3 months"
  },
  "canceledServicesDescription": {
    "en": "Total of canceled services from last 2 months."
  },
  "canceledServicesGreenDescription": {
    "en": "Canceled services from last 5 workdays."
  },
  "canceledServicesYellowDescription": {
    "en": "Canceled services between 5 and 21 workdays ago."
  },
  "canceledServicesRedDescription": {
    "en": "Canceled services more than 21 workdays ago."
  },
  "serviceExpirationGreenDescription": {
    "en": "Service end date is more than 41 workdays from now."
  },
  "serviceExpirationYellowDescription": {
    "en": "Service end date is between 21 and 40 workdays from now."
  },
  "serviceExpirationRedDescription": {
    "en": "Service end date is within next 20 workdays."
  },
  "rel_hw_serial_number No": {
    "en": "HW Serial No"
  },
  "service_start_date": {
    "en": "Service Start Date"
  },
  "service_end_date": {
    "en": "Service End Date"
  },
  "SerialNumber": {
    "en": "Serial Number"
  },
  "cams_error_reason_descr": {
    "en": "Registration Error Description"
  },
  "cams_error_reason_code": {
    "en": "Registration Error Code"
  },
  "cams_error_open_date": {
    "en": "Registration Error Creation Date"
  },
  "registrationErrorsDescription": {
    "en": "Items blocked from registration after auto- or manual registration"
  },
  "cancel_date": {
    "en": "Cancelation Date"
  },
  "rel_hw_product_number": {
    "en": "HW Product No"
  },
  "registeredServicesDescription": {
    "en": "Registered services from last 2 weeks"
  },
  "registeredServicesGreenDescription": {
    "en": "Registered services within the last 3 workdays,"
  },
  "registeredServicesYellowDescription": {
    "en": "Registered services between 4 and 7 workdays ago."
  },
  "registeredServicesRedDescription": {
    "en": "Registered services more than 7 workdays ago."
  },
  "inactive_date": {
    "en": "Inactive Date"
  },
  "chevron_updatedByCustomer": {
    "en": "Updated by Customer"
  },
  "chevron_waitingCustomerUpdate": {
    "en": "Waiting Customer Update"
  }
}
}
